/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StudyHelperApplicationRouteImport } from './routes/study-helper-application'
import { Route as FollowUpPartnerApplicationRouteImport } from './routes/follow-up-partner-application'
import { Route as FollowUpCoordinatorApplicationRouteImport } from './routes/follow-up-coordinator-application'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthRegisterRouteImport } from './routes/_auth.register'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthFirstTimePasswordResetRouteImport } from './routes/_auth.first-time-password-reset'
import { Route as AppNewsletterRouteImport } from './routes/_app/newsletter'
import { Route as AppGroupsRouteImport } from './routes/_app/groups'
import { Route as AppFollowUpsRouteImport } from './routes/_app/follow-ups'
import { Route as AppFollowUpTutorialsRouteImport } from './routes/_app/follow-up-tutorials'
import { Route as AppFollowUpPartnersRouteImport } from './routes/_app/follow-up-partners'
import { Route as AppFollowUpNetworkRouteImport } from './routes/_app/follow-up-network'
import { Route as AppFaqsRouteImport } from './routes/_app/faqs'
import { Route as AppContactRouteImport } from './routes/_app/contact'
import { Route as AppCourseRouteImport } from './routes/_app/_course'
import { Route as AppTutorialsIndexRouteImport } from './routes/_app/tutorials.index'
import { Route as AppStudyHelperBoardIndexRouteImport } from './routes/_app/study-helper-board.index'
import { Route as AppStudentBoardIndexRouteImport } from './routes/_app/student-board.index'
import { Route as AppNotificationsIndexRouteImport } from './routes/_app/notifications.index'
import { Route as AppNewsIndexRouteImport } from './routes/_app/news.index'
import { Route as AppGroupsIndexRouteImport } from './routes/_app/groups.index'
import { Route as AppFollowUpsIndexRouteImport } from './routes/_app/follow-ups.index'
import { Route as AppFollowUpTutorialsIndexRouteImport } from './routes/_app/follow-up-tutorials.index'
import { Route as AppFollowUpStudentsIndexRouteImport } from './routes/_app/follow-up-students.index'
import { Route as AppFollowUpRequestBoardIndexRouteImport } from './routes/_app/follow-up-request-board.index'
import { Route as AppFollowUpPartnersIndexRouteImport } from './routes/_app/follow-up-partners.index'
import { Route as AppFollowUpNetworkIndexRouteImport } from './routes/_app/follow-up-network.index'
import { Route as AppFollowUpCoordinatorsIndexRouteImport } from './routes/_app/follow-up-coordinators.index'
import { Route as AppAllCoursesIndexRouteImport } from './routes/_app/all-courses.index'
import { Route as AppStudyHelperTutorialsSlugRouteImport } from './routes/_app/study-helper-tutorials.$slug'
import { Route as AppStudyHelperNewsSlugRouteImport } from './routes/_app/study-helper-news.$slug'
import { Route as AppStudentNewsSlugRouteImport } from './routes/_app/student-news.$slug'
import { Route as AppNotificationsReadRouteImport } from './routes/_app/notifications.read'
import { Route as AppNewsSlugRouteImport } from './routes/_app/news.$slug'
import { Route as AppFollowUpTutorialsSlugRouteImport } from './routes/_app/follow-up-tutorials.$slug'
import { Route as AppFollowUpPartnersNewRouteImport } from './routes/_app/follow-up-partners.new'
import { Route as AppFollowUpNetworkMapRouteImport } from './routes/_app/follow-up-network.map'
import { Route as AppCoursesCourseSlugRouteImport } from './routes/_app/courses.$courseSlug'
import { Route as AppDashboardGroupsRouteImport } from './routes/_app/_dashboard.groups'
import { Route as AppFollowUpsPendingRequestsIndexRouteImport } from './routes/_app/follow-ups.pending-requests.index'
import { Route as AppFollowUpsEntriesIndexRouteImport } from './routes/_app/follow-ups.entries.index'
import { Route as AppFollowUpsEntriesConvertRouteImport } from './routes/_app/follow-ups.entries.convert'
import { Route as AppUsersMembersMemberIdRouteImport } from './routes/_app/_users.members/$memberId'
import { Route as AppCourseTopicTopicSlugRouteImport } from './routes/_app/_course/topic.$topicSlug'
import { Route as AppCourseQuizzesQuizSlugRouteImport } from './routes/_app/_course/quizzes.$quizSlug'
import { Route as AppCourseLessonsLessonSlugRouteImport } from './routes/_app/_course/lessons.$lessonSlug'
import { Route as AppUsersMembersMemberIdIndexRouteImport } from './routes/_app/_users.members/$memberId.index'
import { Route as AppDashboardGroupsGroupNameIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.index'
import { Route as AppFollowUpsPendingRequestsViewFollowUpIdRouteImport } from './routes/_app/follow-ups.pending-requests.view.$followUpId'
import { Route as AppFollowUpsEntriesViewFollowUpIdRouteImport } from './routes/_app/follow-ups.entries.view.$followUpId'
import { Route as AppUsersMembersMemberIdStudyHelpersRouteImport } from './routes/_app/_users.members/$memberId.study-helpers'
import { Route as AppUsersMembersMemberIdStudentNotesRouteImport } from './routes/_app/_users.members/$memberId.student-notes'
import { Route as AppUsersMembersMemberIdFollowUpsRouteImport } from './routes/_app/_users.members/$memberId.follow-ups'
import { Route as AppUsersMembersMemberIdCourseStudyRouteImport } from './routes/_app/_users.members/$memberId.course-study'
import { Route as AppUsersMembersMemberIdActivityRouteImport } from './routes/_app/_users.members/$memberId.activity'
import { Route as AppDashboardGroupsGroupNameWebAdsTargetsRouteImport } from './routes/_app/_dashboard.groups/$groupName.web-ads-targets'
import { Route as AppDashboardGroupsGroupNameStudentsRouteImport } from './routes/_app/_dashboard.groups/$groupName.students'
import { Route as AppDashboardGroupsGroupNameMassMessagingRouteImport } from './routes/_app/_dashboard.groups/$groupName.mass-messaging'
import { Route as AppDashboardGroupsGroupNameFollowUpsRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups'
import { Route as AppDashboardGroupsGroupNameCampaignsRouteImport } from './routes/_app/_dashboard.groups/$groupName.campaigns'
import { Route as AppDashboardGroupsGroupNameCampaignRouteImport } from './routes/_app/_dashboard.groups/$groupName.campaign'
import { Route as AppDashboardGroupsGroupNameAdminRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin'
import { Route as AppDashboardGroupsGroupNameActivityRouteImport } from './routes/_app/_dashboard.groups/$groupName.activity'
import { Route as AppCourseLessonsLessonSlugQuizRouteImport } from './routes/_app/_course/lessons.$lessonSlug_.quiz'
import { Route as AppUsersMembersMemberIdSettingsIndexRouteImport } from './routes/_app/_users.members/$memberId.settings.index'
import { Route as AppUsersMembersMemberIdProfileIndexRouteImport } from './routes/_app/_users.members/$memberId.profile.index'
import { Route as AppUsersMembersMemberIdMessagesIndexRouteImport } from './routes/_app/_users.members/$memberId.messages.index'
import { Route as AppUsersMembersMemberIdFollowUpsIndexRouteImport } from './routes/_app/_users.members/$memberId.follow-ups.index'
import { Route as AppUsersMembersMemberIdCourseStudyIndexRouteImport } from './routes/_app/_users.members/$memberId.course-study.index'
import { Route as AppDashboardGroupsGroupNameWebTargetsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.web-targets.index'
import { Route as AppDashboardGroupsGroupNameWebAdsTargetsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.web-ads-targets.index'
import { Route as AppDashboardGroupsGroupNameStudentsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.index'
import { Route as AppDashboardGroupsGroupNameStudentBoardIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.student-board.index'
import { Route as AppDashboardGroupsGroupNameMassMessagingIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.mass-messaging.index'
import { Route as AppDashboardGroupsGroupNameGroupMembersIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.group-members.index'
import { Route as AppDashboardGroupsGroupNameFollowUpsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.index'
import { Route as AppDashboardGroupsGroupNameCampaignIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.campaign.index'
import { Route as AppDashboardGroupsGroupNameAdminIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.index'
import { Route as AppUsersMembersMemberIdSettingsNotificationsRouteImport } from './routes/_app/_users.members/$memberId.settings.notifications'
import { Route as AppUsersMembersMemberIdSettingsExportRouteImport } from './routes/_app/_users.members/$memberId.settings.export'
import { Route as AppUsersMembersMemberIdProfileTimelineRouteImport } from './routes/_app/_users.members/$memberId.profile.timeline'
import { Route as AppUsersMembersMemberIdProfileEditRouteImport } from './routes/_app/_users.members/$memberId.profile.edit'
import { Route as AppUsersMembersMemberIdProfileChangeAvatarRouteImport } from './routes/_app/_users.members/$memberId.profile.change-avatar'
import { Route as AppUsersMembersMemberIdMessagesComposeRouteImport } from './routes/_app/_users.members/$memberId.messages.compose'
import { Route as AppUsersMembersMemberIdFollowUpsPendingRequestsRouteImport } from './routes/_app/_users.members/$memberId.follow-ups.pending-requests'
import { Route as AppUsersMembersMemberIdFollowUpsEntriesRouteImport } from './routes/_app/_users.members/$memberId.follow-ups.entries'
import { Route as AppUsersMembersMemberIdCourseStudyStudyActivitiesRouteImport } from './routes/_app/_users.members/$memberId.course-study.study-activities'
import { Route as AppUsersMembersMemberIdCourseStudyQuizzesRouteImport } from './routes/_app/_users.members/$memberId.course-study.quizzes'
import { Route as AppUsersMembersMemberIdCourseStudyCertificatesRouteImport } from './routes/_app/_users.members/$memberId.course-study.certificates'
import { Route as AppDashboardGroupsGroupNameWebAdsTargetsAddRouteImport } from './routes/_app/_dashboard.groups/$groupName.web-ads-targets.add'
import { Route as AppDashboardGroupsGroupNameStudentsStudyActivitiesRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.study-activities'
import { Route as AppDashboardGroupsGroupNameStudentsStudentsWaitingRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.students-waiting'
import { Route as AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.quiz-submissions'
import { Route as AppDashboardGroupsGroupNameStudentsAllStudentsRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.all-students'
import { Route as AppDashboardGroupsGroupNameStudentsAdoptionRequestsRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.adoption-requests'
import { Route as AppDashboardGroupsGroupNameMassMessagingNewRouteImport } from './routes/_app/_dashboard.groups/$groupName.mass-messaging.new'
import { Route as AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.follow-up-requests'
import { Route as AppDashboardGroupsGroupNameCampaignAddRouteImport } from './routes/_app/_dashboard.groups/$groupName.campaign.add'
import { Route as AppDashboardGroupsGroupNameAdminStudentNoticeMsgRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.student-notice-msg'
import { Route as AppDashboardGroupsGroupNameAdminReassignStudentsRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.reassign-students'
import { Route as AppDashboardGroupsGroupNameAdminMemberTaggingRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.member-tagging'
import { Route as AppDashboardGroupsGroupNameAdminGroupAvatarRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.group-avatar'
import { Route as AppUsersMembersMemberIdCourseStudyQuizzesIndexRouteImport } from './routes/_app/_users.members/$memberId.course-study.quizzes.index'
import { Route as AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.quiz-submissions.index'
import { Route as AppDashboardGroupsGroupNameStudentsAllStudentsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.all-students.index'
import { Route as AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.pending-requests.index'
import { Route as AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.follow-up-requests.index'
import { Route as AppDashboardGroupsGroupNameFollowUpsEntriesIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.entries.index'
import { Route as AppDashboardGroupsGroupNameAdminMemberTaggingIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.member-tagging.index'
import { Route as AppUsersMembersMemberIdMessagesViewThreadIdRouteImport } from './routes/_app/_users.members/$memberId.messages.view.$threadId'
import { Route as AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.quiz-submissions.quizzes'
import { Route as AppDashboardGroupsGroupNameStudentsAllStudentsNewRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.all-students.new'
import { Route as AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.follow-up-requests.new'
import { Route as AppDashboardGroupsGroupNameAdminMemberTaggingAddRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.member-tagging.add'
import { Route as AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.quiz-submissions.quizzes.index'
import { Route as AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRouteImport } from './routes/_app/_users.members/$memberId.course-study.quizzes.view.$submissionId'
import { Route as AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRouteImport } from './routes/_app/_users.members/$memberId.course-study.quizzes.grade.$submissionId'
import { Route as AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.pending-requests.view.$requestId'
import { Route as AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRouteImport } from './routes/_app/_dashboard.groups/$groupName.follow-ups.follow-up-requests.view.$requestId'
import { Route as AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRouteImport } from './routes/_app/_dashboard.groups/$groupName.admin.member-tagging.edit.$tagId'
import { Route as AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.quiz-submissions.quizzes.view.$submissionId'
import { Route as AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRouteImport } from './routes/_app/_dashboard.groups/$groupName.students.quiz-submissions.quizzes.grade.$submissionId'

const StudyHelperApplicationRoute = StudyHelperApplicationRouteImport.update({
  id: '/study-helper-application',
  path: '/study-helper-application',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowUpPartnerApplicationRoute =
  FollowUpPartnerApplicationRouteImport.update({
    id: '/follow-up-partner-application',
    path: '/follow-up-partner-application',
    getParentRoute: () => rootRouteImport,
  } as any)
const FollowUpCoordinatorApplicationRoute =
  FollowUpCoordinatorApplicationRouteImport.update({
    id: '/follow-up-coordinator-application',
    path: '/follow-up-coordinator-application',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFirstTimePasswordResetRoute =
  AuthFirstTimePasswordResetRouteImport.update({
    id: '/first-time-password-reset',
    path: '/first-time-password-reset',
    getParentRoute: () => AuthRoute,
  } as any)
const AppNewsletterRoute = AppNewsletterRouteImport.update({
  id: '/newsletter',
  path: '/newsletter',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsRoute = AppGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpsRoute = AppFollowUpsRouteImport.update({
  id: '/follow-ups',
  path: '/follow-ups',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpTutorialsRoute = AppFollowUpTutorialsRouteImport.update({
  id: '/follow-up-tutorials',
  path: '/follow-up-tutorials',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpPartnersRoute = AppFollowUpPartnersRouteImport.update({
  id: '/follow-up-partners',
  path: '/follow-up-partners',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpNetworkRoute = AppFollowUpNetworkRouteImport.update({
  id: '/follow-up-network',
  path: '/follow-up-network',
  getParentRoute: () => AppRoute,
} as any)
const AppFaqsRoute = AppFaqsRouteImport.update({
  id: '/faqs',
  path: '/faqs',
  getParentRoute: () => AppRoute,
} as any)
const AppContactRoute = AppContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => AppRoute,
} as any)
const AppCourseRoute = AppCourseRouteImport.update({
  id: '/_course',
  getParentRoute: () => AppRoute,
} as any)
const AppTutorialsIndexRoute = AppTutorialsIndexRouteImport.update({
  id: '/tutorials/',
  path: '/tutorials/',
  getParentRoute: () => AppRoute,
} as any)
const AppStudyHelperBoardIndexRoute =
  AppStudyHelperBoardIndexRouteImport.update({
    id: '/study-helper-board/',
    path: '/study-helper-board/',
    getParentRoute: () => AppRoute,
  } as any)
const AppStudentBoardIndexRoute = AppStudentBoardIndexRouteImport.update({
  id: '/student-board/',
  path: '/student-board/',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsIndexRoute = AppNotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AppRoute,
} as any)
const AppNewsIndexRoute = AppNewsIndexRouteImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsIndexRoute = AppGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGroupsRoute,
} as any)
const AppFollowUpsIndexRoute = AppFollowUpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFollowUpsRoute,
} as any)
const AppFollowUpTutorialsIndexRoute =
  AppFollowUpTutorialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppFollowUpTutorialsRoute,
  } as any)
const AppFollowUpStudentsIndexRoute =
  AppFollowUpStudentsIndexRouteImport.update({
    id: '/follow-up-students/',
    path: '/follow-up-students/',
    getParentRoute: () => AppRoute,
  } as any)
const AppFollowUpRequestBoardIndexRoute =
  AppFollowUpRequestBoardIndexRouteImport.update({
    id: '/follow-up-request-board/',
    path: '/follow-up-request-board/',
    getParentRoute: () => AppRoute,
  } as any)
const AppFollowUpPartnersIndexRoute =
  AppFollowUpPartnersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppFollowUpPartnersRoute,
  } as any)
const AppFollowUpNetworkIndexRoute = AppFollowUpNetworkIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFollowUpNetworkRoute,
} as any)
const AppFollowUpCoordinatorsIndexRoute =
  AppFollowUpCoordinatorsIndexRouteImport.update({
    id: '/follow-up-coordinators/',
    path: '/follow-up-coordinators/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAllCoursesIndexRoute = AppAllCoursesIndexRouteImport.update({
  id: '/all-courses/',
  path: '/all-courses/',
  getParentRoute: () => AppRoute,
} as any)
const AppStudyHelperTutorialsSlugRoute =
  AppStudyHelperTutorialsSlugRouteImport.update({
    id: '/study-helper-tutorials/$slug',
    path: '/study-helper-tutorials/$slug',
    getParentRoute: () => AppRoute,
  } as any)
const AppStudyHelperNewsSlugRoute = AppStudyHelperNewsSlugRouteImport.update({
  id: '/study-helper-news/$slug',
  path: '/study-helper-news/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppStudentNewsSlugRoute = AppStudentNewsSlugRouteImport.update({
  id: '/student-news/$slug',
  path: '/student-news/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsReadRoute = AppNotificationsReadRouteImport.update({
  id: '/notifications/read',
  path: '/notifications/read',
  getParentRoute: () => AppRoute,
} as any)
const AppNewsSlugRoute = AppNewsSlugRouteImport.update({
  id: '/news/$slug',
  path: '/news/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpTutorialsSlugRoute =
  AppFollowUpTutorialsSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AppFollowUpTutorialsRoute,
  } as any)
const AppFollowUpPartnersNewRoute = AppFollowUpPartnersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppFollowUpPartnersRoute,
} as any)
const AppFollowUpNetworkMapRoute = AppFollowUpNetworkMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppFollowUpNetworkRoute,
} as any)
const AppCoursesCourseSlugRoute = AppCoursesCourseSlugRouteImport.update({
  id: '/courses/$courseSlug',
  path: '/courses/$courseSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardGroupsRoute = AppDashboardGroupsRouteImport.update({
  id: '/_dashboard/groups',
  path: '/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowUpsPendingRequestsIndexRoute =
  AppFollowUpsPendingRequestsIndexRouteImport.update({
    id: '/pending-requests/',
    path: '/pending-requests/',
    getParentRoute: () => AppFollowUpsRoute,
  } as any)
const AppFollowUpsEntriesIndexRoute =
  AppFollowUpsEntriesIndexRouteImport.update({
    id: '/entries/',
    path: '/entries/',
    getParentRoute: () => AppFollowUpsRoute,
  } as any)
const AppFollowUpsEntriesConvertRoute =
  AppFollowUpsEntriesConvertRouteImport.update({
    id: '/entries/convert',
    path: '/entries/convert',
    getParentRoute: () => AppFollowUpsRoute,
  } as any)
const AppUsersMembersMemberIdRoute = AppUsersMembersMemberIdRouteImport.update({
  id: '/_users/members/$memberId',
  path: '/members/$memberId',
  getParentRoute: () => AppRoute,
} as any)
const AppCourseTopicTopicSlugRoute = AppCourseTopicTopicSlugRouteImport.update({
  id: '/topic/$topicSlug',
  path: '/topic/$topicSlug',
  getParentRoute: () => AppCourseRoute,
} as any)
const AppCourseQuizzesQuizSlugRoute =
  AppCourseQuizzesQuizSlugRouteImport.update({
    id: '/quizzes/$quizSlug',
    path: '/quizzes/$quizSlug',
    getParentRoute: () => AppCourseRoute,
  } as any)
const AppCourseLessonsLessonSlugRoute =
  AppCourseLessonsLessonSlugRouteImport.update({
    id: '/lessons/$lessonSlug',
    path: '/lessons/$lessonSlug',
    getParentRoute: () => AppCourseRoute,
  } as any)
const AppUsersMembersMemberIdIndexRoute =
  AppUsersMembersMemberIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppDashboardGroupsGroupNameIndexRoute =
  AppDashboardGroupsGroupNameIndexRouteImport.update({
    id: '/$groupName/',
    path: '/$groupName/',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppFollowUpsPendingRequestsViewFollowUpIdRoute =
  AppFollowUpsPendingRequestsViewFollowUpIdRouteImport.update({
    id: '/pending-requests/view/$followUpId',
    path: '/pending-requests/view/$followUpId',
    getParentRoute: () => AppFollowUpsRoute,
  } as any)
const AppFollowUpsEntriesViewFollowUpIdRoute =
  AppFollowUpsEntriesViewFollowUpIdRouteImport.update({
    id: '/entries/view/$followUpId',
    path: '/entries/view/$followUpId',
    getParentRoute: () => AppFollowUpsRoute,
  } as any)
const AppUsersMembersMemberIdStudyHelpersRoute =
  AppUsersMembersMemberIdStudyHelpersRouteImport.update({
    id: '/study-helpers',
    path: '/study-helpers',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdStudentNotesRoute =
  AppUsersMembersMemberIdStudentNotesRouteImport.update({
    id: '/student-notes',
    path: '/student-notes',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdFollowUpsRoute =
  AppUsersMembersMemberIdFollowUpsRouteImport.update({
    id: '/follow-ups',
    path: '/follow-ups',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyRoute =
  AppUsersMembersMemberIdCourseStudyRouteImport.update({
    id: '/course-study',
    path: '/course-study',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdActivityRoute =
  AppUsersMembersMemberIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppDashboardGroupsGroupNameWebAdsTargetsRoute =
  AppDashboardGroupsGroupNameWebAdsTargetsRouteImport.update({
    id: '/$groupName/web-ads-targets',
    path: '/$groupName/web-ads-targets',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsRoute =
  AppDashboardGroupsGroupNameStudentsRouteImport.update({
    id: '/$groupName/students',
    path: '/$groupName/students',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameMassMessagingRoute =
  AppDashboardGroupsGroupNameMassMessagingRouteImport.update({
    id: '/$groupName/mass-messaging',
    path: '/$groupName/mass-messaging',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsRoute =
  AppDashboardGroupsGroupNameFollowUpsRouteImport.update({
    id: '/$groupName/follow-ups',
    path: '/$groupName/follow-ups',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameCampaignsRoute =
  AppDashboardGroupsGroupNameCampaignsRouteImport.update({
    id: '/$groupName/campaigns',
    path: '/$groupName/campaigns',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameCampaignRoute =
  AppDashboardGroupsGroupNameCampaignRouteImport.update({
    id: '/$groupName/campaign',
    path: '/$groupName/campaign',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminRoute =
  AppDashboardGroupsGroupNameAdminRouteImport.update({
    id: '/$groupName/admin',
    path: '/$groupName/admin',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameActivityRoute =
  AppDashboardGroupsGroupNameActivityRouteImport.update({
    id: '/$groupName/activity',
    path: '/$groupName/activity',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppCourseLessonsLessonSlugQuizRoute =
  AppCourseLessonsLessonSlugQuizRouteImport.update({
    id: '/lessons/$lessonSlug_/quiz',
    path: '/lessons/$lessonSlug/quiz',
    getParentRoute: () => AppCourseRoute,
  } as any)
const AppUsersMembersMemberIdSettingsIndexRoute =
  AppUsersMembersMemberIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdProfileIndexRoute =
  AppUsersMembersMemberIdProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdMessagesIndexRoute =
  AppUsersMembersMemberIdMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdFollowUpsIndexRoute =
  AppUsersMembersMemberIdFollowUpsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUsersMembersMemberIdFollowUpsRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyIndexRoute =
  AppUsersMembersMemberIdCourseStudyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyRoute,
  } as any)
const AppDashboardGroupsGroupNameWebTargetsIndexRoute =
  AppDashboardGroupsGroupNameWebTargetsIndexRouteImport.update({
    id: '/$groupName/web-targets/',
    path: '/$groupName/web-targets/',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute =
  AppDashboardGroupsGroupNameWebAdsTargetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameWebAdsTargetsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsIndexRoute =
  AppDashboardGroupsGroupNameStudentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentBoardIndexRoute =
  AppDashboardGroupsGroupNameStudentBoardIndexRouteImport.update({
    id: '/$groupName/student-board/',
    path: '/$groupName/student-board/',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameMassMessagingIndexRoute =
  AppDashboardGroupsGroupNameMassMessagingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameMassMessagingRoute,
  } as any)
const AppDashboardGroupsGroupNameGroupMembersIndexRoute =
  AppDashboardGroupsGroupNameGroupMembersIndexRouteImport.update({
    id: '/$groupName/group-members/',
    path: '/$groupName/group-members/',
    getParentRoute: () => AppDashboardGroupsRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsIndexRoute =
  AppDashboardGroupsGroupNameFollowUpsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameFollowUpsRoute,
  } as any)
const AppDashboardGroupsGroupNameCampaignIndexRoute =
  AppDashboardGroupsGroupNameCampaignIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameCampaignRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminIndexRoute =
  AppDashboardGroupsGroupNameAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminRoute,
  } as any)
const AppUsersMembersMemberIdSettingsNotificationsRoute =
  AppUsersMembersMemberIdSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdSettingsExportRoute =
  AppUsersMembersMemberIdSettingsExportRouteImport.update({
    id: '/settings/export',
    path: '/settings/export',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdProfileTimelineRoute =
  AppUsersMembersMemberIdProfileTimelineRouteImport.update({
    id: '/profile/timeline',
    path: '/profile/timeline',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdProfileEditRoute =
  AppUsersMembersMemberIdProfileEditRouteImport.update({
    id: '/profile/edit',
    path: '/profile/edit',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdProfileChangeAvatarRoute =
  AppUsersMembersMemberIdProfileChangeAvatarRouteImport.update({
    id: '/profile/change-avatar',
    path: '/profile/change-avatar',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdMessagesComposeRoute =
  AppUsersMembersMemberIdMessagesComposeRouteImport.update({
    id: '/messages/compose',
    path: '/messages/compose',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppUsersMembersMemberIdFollowUpsPendingRequestsRoute =
  AppUsersMembersMemberIdFollowUpsPendingRequestsRouteImport.update({
    id: '/pending-requests',
    path: '/pending-requests',
    getParentRoute: () => AppUsersMembersMemberIdFollowUpsRoute,
  } as any)
const AppUsersMembersMemberIdFollowUpsEntriesRoute =
  AppUsersMembersMemberIdFollowUpsEntriesRouteImport.update({
    id: '/entries',
    path: '/entries',
    getParentRoute: () => AppUsersMembersMemberIdFollowUpsRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute =
  AppUsersMembersMemberIdCourseStudyStudyActivitiesRouteImport.update({
    id: '/study-activities',
    path: '/study-activities',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyQuizzesRoute =
  AppUsersMembersMemberIdCourseStudyQuizzesRouteImport.update({
    id: '/quizzes',
    path: '/quizzes',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyCertificatesRoute =
  AppUsersMembersMemberIdCourseStudyCertificatesRouteImport.update({
    id: '/certificates',
    path: '/certificates',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyRoute,
  } as any)
const AppDashboardGroupsGroupNameWebAdsTargetsAddRoute =
  AppDashboardGroupsGroupNameWebAdsTargetsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AppDashboardGroupsGroupNameWebAdsTargetsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute =
  AppDashboardGroupsGroupNameStudentsStudyActivitiesRouteImport.update({
    id: '/study-activities',
    path: '/study-activities',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute =
  AppDashboardGroupsGroupNameStudentsStudentsWaitingRouteImport.update({
    id: '/students-waiting',
    path: '/students-waiting',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteImport.update({
    id: '/quiz-submissions',
    path: '/quiz-submissions',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsAllStudentsRoute =
  AppDashboardGroupsGroupNameStudentsAllStudentsRouteImport.update({
    id: '/all-students',
    path: '/all-students',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute =
  AppDashboardGroupsGroupNameStudentsAdoptionRequestsRouteImport.update({
    id: '/adoption-requests',
    path: '/adoption-requests',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameMassMessagingNewRoute =
  AppDashboardGroupsGroupNameMassMessagingNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppDashboardGroupsGroupNameMassMessagingRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute =
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteImport.update({
    id: '/follow-up-requests',
    path: '/follow-up-requests',
    getParentRoute: () => AppDashboardGroupsGroupNameFollowUpsRoute,
  } as any)
const AppDashboardGroupsGroupNameCampaignAddRoute =
  AppDashboardGroupsGroupNameCampaignAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AppDashboardGroupsGroupNameCampaignRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute =
  AppDashboardGroupsGroupNameAdminStudentNoticeMsgRouteImport.update({
    id: '/student-notice-msg',
    path: '/student-notice-msg',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminReassignStudentsRoute =
  AppDashboardGroupsGroupNameAdminReassignStudentsRouteImport.update({
    id: '/reassign-students',
    path: '/reassign-students',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminMemberTaggingRoute =
  AppDashboardGroupsGroupNameAdminMemberTaggingRouteImport.update({
    id: '/member-tagging',
    path: '/member-tagging',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminGroupAvatarRoute =
  AppDashboardGroupsGroupNameAdminGroupAvatarRouteImport.update({
    id: '/group-avatar',
    path: '/group-avatar',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute =
  AppUsersMembersMemberIdCourseStudyQuizzesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyQuizzesRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute =
  AppDashboardGroupsGroupNameStudentsAllStudentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsAllStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute =
  AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRouteImport.update({
    id: '/pending-requests/',
    path: '/pending-requests/',
    getParentRoute: () => AppDashboardGroupsGroupNameFollowUpsRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute =
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute =
  AppDashboardGroupsGroupNameFollowUpsEntriesIndexRouteImport.update({
    id: '/entries/',
    path: '/entries/',
    getParentRoute: () => AppDashboardGroupsGroupNameFollowUpsRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute =
  AppDashboardGroupsGroupNameAdminMemberTaggingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminMemberTaggingRoute,
  } as any)
const AppUsersMembersMemberIdMessagesViewThreadIdRoute =
  AppUsersMembersMemberIdMessagesViewThreadIdRouteImport.update({
    id: '/messages/view/$threadId',
    path: '/messages/view/$threadId',
    getParentRoute: () => AppUsersMembersMemberIdRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteImport.update({
    id: '/quizzes',
    path: '/quizzes',
    getParentRoute: () =>
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute =
  AppDashboardGroupsGroupNameStudentsAllStudentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppDashboardGroupsGroupNameStudentsAllStudentsRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute =
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute,
  } as any)
const AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute =
  AppDashboardGroupsGroupNameAdminMemberTaggingAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminMemberTaggingRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute,
    } as any,
  )
const AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute =
  AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRouteImport.update({
    id: '/view/$submissionId',
    path: '/view/$submissionId',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyQuizzesRoute,
  } as any)
const AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute =
  AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRouteImport.update({
    id: '/grade/$submissionId',
    path: '/grade/$submissionId',
    getParentRoute: () => AppUsersMembersMemberIdCourseStudyQuizzesRoute,
  } as any)
const AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute =
  AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRouteImport.update(
    {
      id: '/pending-requests/view/$requestId',
      path: '/pending-requests/view/$requestId',
      getParentRoute: () => AppDashboardGroupsGroupNameFollowUpsRoute,
    } as any,
  )
const AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute =
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRouteImport.update(
    {
      id: '/view/$requestId',
      path: '/view/$requestId',
      getParentRoute: () =>
        AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute,
    } as any,
  )
const AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute =
  AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRouteImport.update({
    id: '/edit/$tagId',
    path: '/edit/$tagId',
    getParentRoute: () => AppDashboardGroupsGroupNameAdminMemberTaggingRoute,
  } as any)
const AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRouteImport.update(
    {
      id: '/view/$submissionId',
      path: '/view/$submissionId',
      getParentRoute: () =>
        AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute,
    } as any,
  )
const AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRouteImport.update(
    {
      id: '/grade/$submissionId',
      path: '/grade/$submissionId',
      getParentRoute: () =>
        AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/follow-up-coordinator-application': typeof FollowUpCoordinatorApplicationRoute
  '/follow-up-partner-application': typeof FollowUpPartnerApplicationRoute
  '/study-helper-application': typeof StudyHelperApplicationRoute
  '/contact': typeof AppContactRoute
  '/faqs': typeof AppFaqsRoute
  '/follow-up-network': typeof AppFollowUpNetworkRouteWithChildren
  '/follow-up-partners': typeof AppFollowUpPartnersRouteWithChildren
  '/follow-up-tutorials': typeof AppFollowUpTutorialsRouteWithChildren
  '/follow-ups': typeof AppFollowUpsRouteWithChildren
  '/groups': typeof AppDashboardGroupsRouteWithChildren
  '/newsletter': typeof AppNewsletterRoute
  '/first-time-password-reset': typeof AuthFirstTimePasswordResetRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/': typeof AppIndexRoute
  '/courses/$courseSlug': typeof AppCoursesCourseSlugRoute
  '/follow-up-network/map': typeof AppFollowUpNetworkMapRoute
  '/follow-up-partners/new': typeof AppFollowUpPartnersNewRoute
  '/follow-up-tutorials/$slug': typeof AppFollowUpTutorialsSlugRoute
  '/news/$slug': typeof AppNewsSlugRoute
  '/notifications/read': typeof AppNotificationsReadRoute
  '/student-news/$slug': typeof AppStudentNewsSlugRoute
  '/study-helper-news/$slug': typeof AppStudyHelperNewsSlugRoute
  '/study-helper-tutorials/$slug': typeof AppStudyHelperTutorialsSlugRoute
  '/all-courses': typeof AppAllCoursesIndexRoute
  '/follow-up-coordinators': typeof AppFollowUpCoordinatorsIndexRoute
  '/follow-up-network/': typeof AppFollowUpNetworkIndexRoute
  '/follow-up-partners/': typeof AppFollowUpPartnersIndexRoute
  '/follow-up-request-board': typeof AppFollowUpRequestBoardIndexRoute
  '/follow-up-students': typeof AppFollowUpStudentsIndexRoute
  '/follow-up-tutorials/': typeof AppFollowUpTutorialsIndexRoute
  '/follow-ups/': typeof AppFollowUpsIndexRoute
  '/groups/': typeof AppGroupsIndexRoute
  '/news': typeof AppNewsIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/student-board': typeof AppStudentBoardIndexRoute
  '/study-helper-board': typeof AppStudyHelperBoardIndexRoute
  '/tutorials': typeof AppTutorialsIndexRoute
  '/lessons/$lessonSlug': typeof AppCourseLessonsLessonSlugRoute
  '/quizzes/$quizSlug': typeof AppCourseQuizzesQuizSlugRoute
  '/topic/$topicSlug': typeof AppCourseTopicTopicSlugRoute
  '/members/$memberId': typeof AppUsersMembersMemberIdRouteWithChildren
  '/follow-ups/entries/convert': typeof AppFollowUpsEntriesConvertRoute
  '/follow-ups/entries': typeof AppFollowUpsEntriesIndexRoute
  '/follow-ups/pending-requests': typeof AppFollowUpsPendingRequestsIndexRoute
  '/lessons/$lessonSlug/quiz': typeof AppCourseLessonsLessonSlugQuizRoute
  '/groups/$groupName/activity': typeof AppDashboardGroupsGroupNameActivityRoute
  '/groups/$groupName/admin': typeof AppDashboardGroupsGroupNameAdminRouteWithChildren
  '/groups/$groupName/campaign': typeof AppDashboardGroupsGroupNameCampaignRouteWithChildren
  '/groups/$groupName/campaigns': typeof AppDashboardGroupsGroupNameCampaignsRoute
  '/groups/$groupName/follow-ups': typeof AppDashboardGroupsGroupNameFollowUpsRouteWithChildren
  '/groups/$groupName/mass-messaging': typeof AppDashboardGroupsGroupNameMassMessagingRouteWithChildren
  '/groups/$groupName/students': typeof AppDashboardGroupsGroupNameStudentsRouteWithChildren
  '/groups/$groupName/web-ads-targets': typeof AppDashboardGroupsGroupNameWebAdsTargetsRouteWithChildren
  '/members/$memberId/activity': typeof AppUsersMembersMemberIdActivityRoute
  '/members/$memberId/course-study': typeof AppUsersMembersMemberIdCourseStudyRouteWithChildren
  '/members/$memberId/follow-ups': typeof AppUsersMembersMemberIdFollowUpsRouteWithChildren
  '/members/$memberId/student-notes': typeof AppUsersMembersMemberIdStudentNotesRoute
  '/members/$memberId/study-helpers': typeof AppUsersMembersMemberIdStudyHelpersRoute
  '/follow-ups/entries/view/$followUpId': typeof AppFollowUpsEntriesViewFollowUpIdRoute
  '/follow-ups/pending-requests/view/$followUpId': typeof AppFollowUpsPendingRequestsViewFollowUpIdRoute
  '/groups/$groupName': typeof AppDashboardGroupsGroupNameIndexRoute
  '/members/$memberId/': typeof AppUsersMembersMemberIdIndexRoute
  '/groups/$groupName/admin/group-avatar': typeof AppDashboardGroupsGroupNameAdminGroupAvatarRoute
  '/groups/$groupName/admin/member-tagging': typeof AppDashboardGroupsGroupNameAdminMemberTaggingRouteWithChildren
  '/groups/$groupName/admin/reassign-students': typeof AppDashboardGroupsGroupNameAdminReassignStudentsRoute
  '/groups/$groupName/admin/student-notice-msg': typeof AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute
  '/groups/$groupName/campaign/add': typeof AppDashboardGroupsGroupNameCampaignAddRoute
  '/groups/$groupName/follow-ups/follow-up-requests': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteWithChildren
  '/groups/$groupName/mass-messaging/new': typeof AppDashboardGroupsGroupNameMassMessagingNewRoute
  '/groups/$groupName/students/adoption-requests': typeof AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute
  '/groups/$groupName/students/all-students': typeof AppDashboardGroupsGroupNameStudentsAllStudentsRouteWithChildren
  '/groups/$groupName/students/quiz-submissions': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteWithChildren
  '/groups/$groupName/students/students-waiting': typeof AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute
  '/groups/$groupName/students/study-activities': typeof AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute
  '/groups/$groupName/web-ads-targets/add': typeof AppDashboardGroupsGroupNameWebAdsTargetsAddRoute
  '/members/$memberId/course-study/certificates': typeof AppUsersMembersMemberIdCourseStudyCertificatesRoute
  '/members/$memberId/course-study/quizzes': typeof AppUsersMembersMemberIdCourseStudyQuizzesRouteWithChildren
  '/members/$memberId/course-study/study-activities': typeof AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute
  '/members/$memberId/follow-ups/entries': typeof AppUsersMembersMemberIdFollowUpsEntriesRoute
  '/members/$memberId/follow-ups/pending-requests': typeof AppUsersMembersMemberIdFollowUpsPendingRequestsRoute
  '/members/$memberId/messages/compose': typeof AppUsersMembersMemberIdMessagesComposeRoute
  '/members/$memberId/profile/change-avatar': typeof AppUsersMembersMemberIdProfileChangeAvatarRoute
  '/members/$memberId/profile/edit': typeof AppUsersMembersMemberIdProfileEditRoute
  '/members/$memberId/profile/timeline': typeof AppUsersMembersMemberIdProfileTimelineRoute
  '/members/$memberId/settings/export': typeof AppUsersMembersMemberIdSettingsExportRoute
  '/members/$memberId/settings/notifications': typeof AppUsersMembersMemberIdSettingsNotificationsRoute
  '/groups/$groupName/admin/': typeof AppDashboardGroupsGroupNameAdminIndexRoute
  '/groups/$groupName/campaign/': typeof AppDashboardGroupsGroupNameCampaignIndexRoute
  '/groups/$groupName/follow-ups/': typeof AppDashboardGroupsGroupNameFollowUpsIndexRoute
  '/groups/$groupName/group-members': typeof AppDashboardGroupsGroupNameGroupMembersIndexRoute
  '/groups/$groupName/mass-messaging/': typeof AppDashboardGroupsGroupNameMassMessagingIndexRoute
  '/groups/$groupName/student-board': typeof AppDashboardGroupsGroupNameStudentBoardIndexRoute
  '/groups/$groupName/students/': typeof AppDashboardGroupsGroupNameStudentsIndexRoute
  '/groups/$groupName/web-ads-targets/': typeof AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute
  '/groups/$groupName/web-targets': typeof AppDashboardGroupsGroupNameWebTargetsIndexRoute
  '/members/$memberId/course-study/': typeof AppUsersMembersMemberIdCourseStudyIndexRoute
  '/members/$memberId/follow-ups/': typeof AppUsersMembersMemberIdFollowUpsIndexRoute
  '/members/$memberId/messages': typeof AppUsersMembersMemberIdMessagesIndexRoute
  '/members/$memberId/profile': typeof AppUsersMembersMemberIdProfileIndexRoute
  '/members/$memberId/settings': typeof AppUsersMembersMemberIdSettingsIndexRoute
  '/groups/$groupName/admin/member-tagging/add': typeof AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute
  '/groups/$groupName/follow-ups/follow-up-requests/new': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute
  '/groups/$groupName/students/all-students/new': typeof AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute
  '/groups/$groupName/students/quiz-submissions/quizzes': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteWithChildren
  '/members/$memberId/messages/view/$threadId': typeof AppUsersMembersMemberIdMessagesViewThreadIdRoute
  '/groups/$groupName/admin/member-tagging/': typeof AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute
  '/groups/$groupName/follow-ups/entries': typeof AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute
  '/groups/$groupName/follow-ups/follow-up-requests/': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute
  '/groups/$groupName/follow-ups/pending-requests': typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute
  '/groups/$groupName/students/all-students/': typeof AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute
  '/groups/$groupName/students/quiz-submissions/': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute
  '/members/$memberId/course-study/quizzes/': typeof AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute
  '/groups/$groupName/admin/member-tagging/edit/$tagId': typeof AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute
  '/groups/$groupName/follow-ups/follow-up-requests/view/$requestId': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute
  '/groups/$groupName/follow-ups/pending-requests/view/$requestId': typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute
  '/members/$memberId/course-study/quizzes/grade/$submissionId': typeof AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute
  '/members/$memberId/course-study/quizzes/view/$submissionId': typeof AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute
  '/groups/$groupName/students/quiz-submissions/quizzes/': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute
  '/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute
  '/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute
}
export interface FileRoutesByTo {
  '/follow-up-coordinator-application': typeof FollowUpCoordinatorApplicationRoute
  '/follow-up-partner-application': typeof FollowUpPartnerApplicationRoute
  '/study-helper-application': typeof StudyHelperApplicationRoute
  '/contact': typeof AppContactRoute
  '/faqs': typeof AppFaqsRoute
  '/newsletter': typeof AppNewsletterRoute
  '/first-time-password-reset': typeof AuthFirstTimePasswordResetRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/': typeof AppIndexRoute
  '/groups': typeof AppGroupsIndexRoute
  '/courses/$courseSlug': typeof AppCoursesCourseSlugRoute
  '/follow-up-network/map': typeof AppFollowUpNetworkMapRoute
  '/follow-up-partners/new': typeof AppFollowUpPartnersNewRoute
  '/follow-up-tutorials/$slug': typeof AppFollowUpTutorialsSlugRoute
  '/news/$slug': typeof AppNewsSlugRoute
  '/notifications/read': typeof AppNotificationsReadRoute
  '/student-news/$slug': typeof AppStudentNewsSlugRoute
  '/study-helper-news/$slug': typeof AppStudyHelperNewsSlugRoute
  '/study-helper-tutorials/$slug': typeof AppStudyHelperTutorialsSlugRoute
  '/all-courses': typeof AppAllCoursesIndexRoute
  '/follow-up-coordinators': typeof AppFollowUpCoordinatorsIndexRoute
  '/follow-up-network': typeof AppFollowUpNetworkIndexRoute
  '/follow-up-partners': typeof AppFollowUpPartnersIndexRoute
  '/follow-up-request-board': typeof AppFollowUpRequestBoardIndexRoute
  '/follow-up-students': typeof AppFollowUpStudentsIndexRoute
  '/follow-up-tutorials': typeof AppFollowUpTutorialsIndexRoute
  '/follow-ups': typeof AppFollowUpsIndexRoute
  '/news': typeof AppNewsIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/student-board': typeof AppStudentBoardIndexRoute
  '/study-helper-board': typeof AppStudyHelperBoardIndexRoute
  '/tutorials': typeof AppTutorialsIndexRoute
  '/lessons/$lessonSlug': typeof AppCourseLessonsLessonSlugRoute
  '/quizzes/$quizSlug': typeof AppCourseQuizzesQuizSlugRoute
  '/topic/$topicSlug': typeof AppCourseTopicTopicSlugRoute
  '/follow-ups/entries/convert': typeof AppFollowUpsEntriesConvertRoute
  '/follow-ups/entries': typeof AppFollowUpsEntriesIndexRoute
  '/follow-ups/pending-requests': typeof AppFollowUpsPendingRequestsIndexRoute
  '/lessons/$lessonSlug/quiz': typeof AppCourseLessonsLessonSlugQuizRoute
  '/groups/$groupName/activity': typeof AppDashboardGroupsGroupNameActivityRoute
  '/groups/$groupName/campaigns': typeof AppDashboardGroupsGroupNameCampaignsRoute
  '/members/$memberId/activity': typeof AppUsersMembersMemberIdActivityRoute
  '/members/$memberId/student-notes': typeof AppUsersMembersMemberIdStudentNotesRoute
  '/members/$memberId/study-helpers': typeof AppUsersMembersMemberIdStudyHelpersRoute
  '/follow-ups/entries/view/$followUpId': typeof AppFollowUpsEntriesViewFollowUpIdRoute
  '/follow-ups/pending-requests/view/$followUpId': typeof AppFollowUpsPendingRequestsViewFollowUpIdRoute
  '/groups/$groupName': typeof AppDashboardGroupsGroupNameIndexRoute
  '/members/$memberId': typeof AppUsersMembersMemberIdIndexRoute
  '/groups/$groupName/admin/group-avatar': typeof AppDashboardGroupsGroupNameAdminGroupAvatarRoute
  '/groups/$groupName/admin/reassign-students': typeof AppDashboardGroupsGroupNameAdminReassignStudentsRoute
  '/groups/$groupName/admin/student-notice-msg': typeof AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute
  '/groups/$groupName/campaign/add': typeof AppDashboardGroupsGroupNameCampaignAddRoute
  '/groups/$groupName/mass-messaging/new': typeof AppDashboardGroupsGroupNameMassMessagingNewRoute
  '/groups/$groupName/students/adoption-requests': typeof AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute
  '/groups/$groupName/students/students-waiting': typeof AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute
  '/groups/$groupName/students/study-activities': typeof AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute
  '/groups/$groupName/web-ads-targets/add': typeof AppDashboardGroupsGroupNameWebAdsTargetsAddRoute
  '/members/$memberId/course-study/certificates': typeof AppUsersMembersMemberIdCourseStudyCertificatesRoute
  '/members/$memberId/course-study/study-activities': typeof AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute
  '/members/$memberId/follow-ups/entries': typeof AppUsersMembersMemberIdFollowUpsEntriesRoute
  '/members/$memberId/follow-ups/pending-requests': typeof AppUsersMembersMemberIdFollowUpsPendingRequestsRoute
  '/members/$memberId/messages/compose': typeof AppUsersMembersMemberIdMessagesComposeRoute
  '/members/$memberId/profile/change-avatar': typeof AppUsersMembersMemberIdProfileChangeAvatarRoute
  '/members/$memberId/profile/edit': typeof AppUsersMembersMemberIdProfileEditRoute
  '/members/$memberId/profile/timeline': typeof AppUsersMembersMemberIdProfileTimelineRoute
  '/members/$memberId/settings/export': typeof AppUsersMembersMemberIdSettingsExportRoute
  '/members/$memberId/settings/notifications': typeof AppUsersMembersMemberIdSettingsNotificationsRoute
  '/groups/$groupName/admin': typeof AppDashboardGroupsGroupNameAdminIndexRoute
  '/groups/$groupName/campaign': typeof AppDashboardGroupsGroupNameCampaignIndexRoute
  '/groups/$groupName/follow-ups': typeof AppDashboardGroupsGroupNameFollowUpsIndexRoute
  '/groups/$groupName/group-members': typeof AppDashboardGroupsGroupNameGroupMembersIndexRoute
  '/groups/$groupName/mass-messaging': typeof AppDashboardGroupsGroupNameMassMessagingIndexRoute
  '/groups/$groupName/student-board': typeof AppDashboardGroupsGroupNameStudentBoardIndexRoute
  '/groups/$groupName/students': typeof AppDashboardGroupsGroupNameStudentsIndexRoute
  '/groups/$groupName/web-ads-targets': typeof AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute
  '/groups/$groupName/web-targets': typeof AppDashboardGroupsGroupNameWebTargetsIndexRoute
  '/members/$memberId/course-study': typeof AppUsersMembersMemberIdCourseStudyIndexRoute
  '/members/$memberId/follow-ups': typeof AppUsersMembersMemberIdFollowUpsIndexRoute
  '/members/$memberId/messages': typeof AppUsersMembersMemberIdMessagesIndexRoute
  '/members/$memberId/profile': typeof AppUsersMembersMemberIdProfileIndexRoute
  '/members/$memberId/settings': typeof AppUsersMembersMemberIdSettingsIndexRoute
  '/groups/$groupName/admin/member-tagging/add': typeof AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute
  '/groups/$groupName/follow-ups/follow-up-requests/new': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute
  '/groups/$groupName/students/all-students/new': typeof AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute
  '/members/$memberId/messages/view/$threadId': typeof AppUsersMembersMemberIdMessagesViewThreadIdRoute
  '/groups/$groupName/admin/member-tagging': typeof AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute
  '/groups/$groupName/follow-ups/entries': typeof AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute
  '/groups/$groupName/follow-ups/follow-up-requests': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute
  '/groups/$groupName/follow-ups/pending-requests': typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute
  '/groups/$groupName/students/all-students': typeof AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute
  '/groups/$groupName/students/quiz-submissions': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute
  '/members/$memberId/course-study/quizzes': typeof AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute
  '/groups/$groupName/admin/member-tagging/edit/$tagId': typeof AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute
  '/groups/$groupName/follow-ups/follow-up-requests/view/$requestId': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute
  '/groups/$groupName/follow-ups/pending-requests/view/$requestId': typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute
  '/members/$memberId/course-study/quizzes/grade/$submissionId': typeof AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute
  '/members/$memberId/course-study/quizzes/view/$submissionId': typeof AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute
  '/groups/$groupName/students/quiz-submissions/quizzes': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute
  '/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute
  '/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/follow-up-coordinator-application': typeof FollowUpCoordinatorApplicationRoute
  '/follow-up-partner-application': typeof FollowUpPartnerApplicationRoute
  '/study-helper-application': typeof StudyHelperApplicationRoute
  '/_app/_course': typeof AppCourseRouteWithChildren
  '/_app/contact': typeof AppContactRoute
  '/_app/faqs': typeof AppFaqsRoute
  '/_app/follow-up-network': typeof AppFollowUpNetworkRouteWithChildren
  '/_app/follow-up-partners': typeof AppFollowUpPartnersRouteWithChildren
  '/_app/follow-up-tutorials': typeof AppFollowUpTutorialsRouteWithChildren
  '/_app/follow-ups': typeof AppFollowUpsRouteWithChildren
  '/_app/groups': typeof AppGroupsRouteWithChildren
  '/_app/newsletter': typeof AppNewsletterRoute
  '/_auth/first-time-password-reset': typeof AuthFirstTimePasswordResetRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_app/': typeof AppIndexRoute
  '/_app/_dashboard/groups': typeof AppDashboardGroupsRouteWithChildren
  '/_app/courses/$courseSlug': typeof AppCoursesCourseSlugRoute
  '/_app/follow-up-network/map': typeof AppFollowUpNetworkMapRoute
  '/_app/follow-up-partners/new': typeof AppFollowUpPartnersNewRoute
  '/_app/follow-up-tutorials/$slug': typeof AppFollowUpTutorialsSlugRoute
  '/_app/news/$slug': typeof AppNewsSlugRoute
  '/_app/notifications/read': typeof AppNotificationsReadRoute
  '/_app/student-news/$slug': typeof AppStudentNewsSlugRoute
  '/_app/study-helper-news/$slug': typeof AppStudyHelperNewsSlugRoute
  '/_app/study-helper-tutorials/$slug': typeof AppStudyHelperTutorialsSlugRoute
  '/_app/all-courses/': typeof AppAllCoursesIndexRoute
  '/_app/follow-up-coordinators/': typeof AppFollowUpCoordinatorsIndexRoute
  '/_app/follow-up-network/': typeof AppFollowUpNetworkIndexRoute
  '/_app/follow-up-partners/': typeof AppFollowUpPartnersIndexRoute
  '/_app/follow-up-request-board/': typeof AppFollowUpRequestBoardIndexRoute
  '/_app/follow-up-students/': typeof AppFollowUpStudentsIndexRoute
  '/_app/follow-up-tutorials/': typeof AppFollowUpTutorialsIndexRoute
  '/_app/follow-ups/': typeof AppFollowUpsIndexRoute
  '/_app/groups/': typeof AppGroupsIndexRoute
  '/_app/news/': typeof AppNewsIndexRoute
  '/_app/notifications/': typeof AppNotificationsIndexRoute
  '/_app/student-board/': typeof AppStudentBoardIndexRoute
  '/_app/study-helper-board/': typeof AppStudyHelperBoardIndexRoute
  '/_app/tutorials/': typeof AppTutorialsIndexRoute
  '/_app/_course/lessons/$lessonSlug': typeof AppCourseLessonsLessonSlugRoute
  '/_app/_course/quizzes/$quizSlug': typeof AppCourseQuizzesQuizSlugRoute
  '/_app/_course/topic/$topicSlug': typeof AppCourseTopicTopicSlugRoute
  '/_app/_users/members/$memberId': typeof AppUsersMembersMemberIdRouteWithChildren
  '/_app/follow-ups/entries/convert': typeof AppFollowUpsEntriesConvertRoute
  '/_app/follow-ups/entries/': typeof AppFollowUpsEntriesIndexRoute
  '/_app/follow-ups/pending-requests/': typeof AppFollowUpsPendingRequestsIndexRoute
  '/_app/_course/lessons/$lessonSlug_/quiz': typeof AppCourseLessonsLessonSlugQuizRoute
  '/_app/_dashboard/groups/$groupName/activity': typeof AppDashboardGroupsGroupNameActivityRoute
  '/_app/_dashboard/groups/$groupName/admin': typeof AppDashboardGroupsGroupNameAdminRouteWithChildren
  '/_app/_dashboard/groups/$groupName/campaign': typeof AppDashboardGroupsGroupNameCampaignRouteWithChildren
  '/_app/_dashboard/groups/$groupName/campaigns': typeof AppDashboardGroupsGroupNameCampaignsRoute
  '/_app/_dashboard/groups/$groupName/follow-ups': typeof AppDashboardGroupsGroupNameFollowUpsRouteWithChildren
  '/_app/_dashboard/groups/$groupName/mass-messaging': typeof AppDashboardGroupsGroupNameMassMessagingRouteWithChildren
  '/_app/_dashboard/groups/$groupName/students': typeof AppDashboardGroupsGroupNameStudentsRouteWithChildren
  '/_app/_dashboard/groups/$groupName/web-ads-targets': typeof AppDashboardGroupsGroupNameWebAdsTargetsRouteWithChildren
  '/_app/_users/members/$memberId/activity': typeof AppUsersMembersMemberIdActivityRoute
  '/_app/_users/members/$memberId/course-study': typeof AppUsersMembersMemberIdCourseStudyRouteWithChildren
  '/_app/_users/members/$memberId/follow-ups': typeof AppUsersMembersMemberIdFollowUpsRouteWithChildren
  '/_app/_users/members/$memberId/student-notes': typeof AppUsersMembersMemberIdStudentNotesRoute
  '/_app/_users/members/$memberId/study-helpers': typeof AppUsersMembersMemberIdStudyHelpersRoute
  '/_app/follow-ups/entries/view/$followUpId': typeof AppFollowUpsEntriesViewFollowUpIdRoute
  '/_app/follow-ups/pending-requests/view/$followUpId': typeof AppFollowUpsPendingRequestsViewFollowUpIdRoute
  '/_app/_dashboard/groups/$groupName/': typeof AppDashboardGroupsGroupNameIndexRoute
  '/_app/_users/members/$memberId/': typeof AppUsersMembersMemberIdIndexRoute
  '/_app/_dashboard/groups/$groupName/admin/group-avatar': typeof AppDashboardGroupsGroupNameAdminGroupAvatarRoute
  '/_app/_dashboard/groups/$groupName/admin/member-tagging': typeof AppDashboardGroupsGroupNameAdminMemberTaggingRouteWithChildren
  '/_app/_dashboard/groups/$groupName/admin/reassign-students': typeof AppDashboardGroupsGroupNameAdminReassignStudentsRoute
  '/_app/_dashboard/groups/$groupName/admin/student-notice-msg': typeof AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute
  '/_app/_dashboard/groups/$groupName/campaign/add': typeof AppDashboardGroupsGroupNameCampaignAddRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteWithChildren
  '/_app/_dashboard/groups/$groupName/mass-messaging/new': typeof AppDashboardGroupsGroupNameMassMessagingNewRoute
  '/_app/_dashboard/groups/$groupName/students/adoption-requests': typeof AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute
  '/_app/_dashboard/groups/$groupName/students/all-students': typeof AppDashboardGroupsGroupNameStudentsAllStudentsRouteWithChildren
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteWithChildren
  '/_app/_dashboard/groups/$groupName/students/students-waiting': typeof AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute
  '/_app/_dashboard/groups/$groupName/students/study-activities': typeof AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute
  '/_app/_dashboard/groups/$groupName/web-ads-targets/add': typeof AppDashboardGroupsGroupNameWebAdsTargetsAddRoute
  '/_app/_users/members/$memberId/course-study/certificates': typeof AppUsersMembersMemberIdCourseStudyCertificatesRoute
  '/_app/_users/members/$memberId/course-study/quizzes': typeof AppUsersMembersMemberIdCourseStudyQuizzesRouteWithChildren
  '/_app/_users/members/$memberId/course-study/study-activities': typeof AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute
  '/_app/_users/members/$memberId/follow-ups/entries': typeof AppUsersMembersMemberIdFollowUpsEntriesRoute
  '/_app/_users/members/$memberId/follow-ups/pending-requests': typeof AppUsersMembersMemberIdFollowUpsPendingRequestsRoute
  '/_app/_users/members/$memberId/messages/compose': typeof AppUsersMembersMemberIdMessagesComposeRoute
  '/_app/_users/members/$memberId/profile/change-avatar': typeof AppUsersMembersMemberIdProfileChangeAvatarRoute
  '/_app/_users/members/$memberId/profile/edit': typeof AppUsersMembersMemberIdProfileEditRoute
  '/_app/_users/members/$memberId/profile/timeline': typeof AppUsersMembersMemberIdProfileTimelineRoute
  '/_app/_users/members/$memberId/settings/export': typeof AppUsersMembersMemberIdSettingsExportRoute
  '/_app/_users/members/$memberId/settings/notifications': typeof AppUsersMembersMemberIdSettingsNotificationsRoute
  '/_app/_dashboard/groups/$groupName/admin/': typeof AppDashboardGroupsGroupNameAdminIndexRoute
  '/_app/_dashboard/groups/$groupName/campaign/': typeof AppDashboardGroupsGroupNameCampaignIndexRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/': typeof AppDashboardGroupsGroupNameFollowUpsIndexRoute
  '/_app/_dashboard/groups/$groupName/group-members/': typeof AppDashboardGroupsGroupNameGroupMembersIndexRoute
  '/_app/_dashboard/groups/$groupName/mass-messaging/': typeof AppDashboardGroupsGroupNameMassMessagingIndexRoute
  '/_app/_dashboard/groups/$groupName/student-board/': typeof AppDashboardGroupsGroupNameStudentBoardIndexRoute
  '/_app/_dashboard/groups/$groupName/students/': typeof AppDashboardGroupsGroupNameStudentsIndexRoute
  '/_app/_dashboard/groups/$groupName/web-ads-targets/': typeof AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute
  '/_app/_dashboard/groups/$groupName/web-targets/': typeof AppDashboardGroupsGroupNameWebTargetsIndexRoute
  '/_app/_users/members/$memberId/course-study/': typeof AppUsersMembersMemberIdCourseStudyIndexRoute
  '/_app/_users/members/$memberId/follow-ups/': typeof AppUsersMembersMemberIdFollowUpsIndexRoute
  '/_app/_users/members/$memberId/messages/': typeof AppUsersMembersMemberIdMessagesIndexRoute
  '/_app/_users/members/$memberId/profile/': typeof AppUsersMembersMemberIdProfileIndexRoute
  '/_app/_users/members/$memberId/settings/': typeof AppUsersMembersMemberIdSettingsIndexRoute
  '/_app/_dashboard/groups/$groupName/admin/member-tagging/add': typeof AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/new': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute
  '/_app/_dashboard/groups/$groupName/students/all-students/new': typeof AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteWithChildren
  '/_app/_users/members/$memberId/messages/view/$threadId': typeof AppUsersMembersMemberIdMessagesViewThreadIdRoute
  '/_app/_dashboard/groups/$groupName/admin/member-tagging/': typeof AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/entries/': typeof AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/': typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute
  '/_app/_dashboard/groups/$groupName/students/all-students/': typeof AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute
  '/_app/_users/members/$memberId/course-study/quizzes/': typeof AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute
  '/_app/_dashboard/groups/$groupName/admin/member-tagging/edit/$tagId': typeof AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/view/$requestId': typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute
  '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/view/$requestId': typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute
  '/_app/_users/members/$memberId/course-study/quizzes/grade/$submissionId': typeof AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute
  '/_app/_users/members/$memberId/course-study/quizzes/view/$submissionId': typeof AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId': typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/follow-up-coordinator-application'
    | '/follow-up-partner-application'
    | '/study-helper-application'
    | '/contact'
    | '/faqs'
    | '/follow-up-network'
    | '/follow-up-partners'
    | '/follow-up-tutorials'
    | '/follow-ups'
    | '/groups'
    | '/newsletter'
    | '/first-time-password-reset'
    | '/login'
    | '/register'
    | '/'
    | '/courses/$courseSlug'
    | '/follow-up-network/map'
    | '/follow-up-partners/new'
    | '/follow-up-tutorials/$slug'
    | '/news/$slug'
    | '/notifications/read'
    | '/student-news/$slug'
    | '/study-helper-news/$slug'
    | '/study-helper-tutorials/$slug'
    | '/all-courses'
    | '/follow-up-coordinators'
    | '/follow-up-network/'
    | '/follow-up-partners/'
    | '/follow-up-request-board'
    | '/follow-up-students'
    | '/follow-up-tutorials/'
    | '/follow-ups/'
    | '/groups/'
    | '/news'
    | '/notifications'
    | '/student-board'
    | '/study-helper-board'
    | '/tutorials'
    | '/lessons/$lessonSlug'
    | '/quizzes/$quizSlug'
    | '/topic/$topicSlug'
    | '/members/$memberId'
    | '/follow-ups/entries/convert'
    | '/follow-ups/entries'
    | '/follow-ups/pending-requests'
    | '/lessons/$lessonSlug/quiz'
    | '/groups/$groupName/activity'
    | '/groups/$groupName/admin'
    | '/groups/$groupName/campaign'
    | '/groups/$groupName/campaigns'
    | '/groups/$groupName/follow-ups'
    | '/groups/$groupName/mass-messaging'
    | '/groups/$groupName/students'
    | '/groups/$groupName/web-ads-targets'
    | '/members/$memberId/activity'
    | '/members/$memberId/course-study'
    | '/members/$memberId/follow-ups'
    | '/members/$memberId/student-notes'
    | '/members/$memberId/study-helpers'
    | '/follow-ups/entries/view/$followUpId'
    | '/follow-ups/pending-requests/view/$followUpId'
    | '/groups/$groupName'
    | '/members/$memberId/'
    | '/groups/$groupName/admin/group-avatar'
    | '/groups/$groupName/admin/member-tagging'
    | '/groups/$groupName/admin/reassign-students'
    | '/groups/$groupName/admin/student-notice-msg'
    | '/groups/$groupName/campaign/add'
    | '/groups/$groupName/follow-ups/follow-up-requests'
    | '/groups/$groupName/mass-messaging/new'
    | '/groups/$groupName/students/adoption-requests'
    | '/groups/$groupName/students/all-students'
    | '/groups/$groupName/students/quiz-submissions'
    | '/groups/$groupName/students/students-waiting'
    | '/groups/$groupName/students/study-activities'
    | '/groups/$groupName/web-ads-targets/add'
    | '/members/$memberId/course-study/certificates'
    | '/members/$memberId/course-study/quizzes'
    | '/members/$memberId/course-study/study-activities'
    | '/members/$memberId/follow-ups/entries'
    | '/members/$memberId/follow-ups/pending-requests'
    | '/members/$memberId/messages/compose'
    | '/members/$memberId/profile/change-avatar'
    | '/members/$memberId/profile/edit'
    | '/members/$memberId/profile/timeline'
    | '/members/$memberId/settings/export'
    | '/members/$memberId/settings/notifications'
    | '/groups/$groupName/admin/'
    | '/groups/$groupName/campaign/'
    | '/groups/$groupName/follow-ups/'
    | '/groups/$groupName/group-members'
    | '/groups/$groupName/mass-messaging/'
    | '/groups/$groupName/student-board'
    | '/groups/$groupName/students/'
    | '/groups/$groupName/web-ads-targets/'
    | '/groups/$groupName/web-targets'
    | '/members/$memberId/course-study/'
    | '/members/$memberId/follow-ups/'
    | '/members/$memberId/messages'
    | '/members/$memberId/profile'
    | '/members/$memberId/settings'
    | '/groups/$groupName/admin/member-tagging/add'
    | '/groups/$groupName/follow-ups/follow-up-requests/new'
    | '/groups/$groupName/students/all-students/new'
    | '/groups/$groupName/students/quiz-submissions/quizzes'
    | '/members/$memberId/messages/view/$threadId'
    | '/groups/$groupName/admin/member-tagging/'
    | '/groups/$groupName/follow-ups/entries'
    | '/groups/$groupName/follow-ups/follow-up-requests/'
    | '/groups/$groupName/follow-ups/pending-requests'
    | '/groups/$groupName/students/all-students/'
    | '/groups/$groupName/students/quiz-submissions/'
    | '/members/$memberId/course-study/quizzes/'
    | '/groups/$groupName/admin/member-tagging/edit/$tagId'
    | '/groups/$groupName/follow-ups/follow-up-requests/view/$requestId'
    | '/groups/$groupName/follow-ups/pending-requests/view/$requestId'
    | '/members/$memberId/course-study/quizzes/grade/$submissionId'
    | '/members/$memberId/course-study/quizzes/view/$submissionId'
    | '/groups/$groupName/students/quiz-submissions/quizzes/'
    | '/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId'
    | '/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/follow-up-coordinator-application'
    | '/follow-up-partner-application'
    | '/study-helper-application'
    | '/contact'
    | '/faqs'
    | '/newsletter'
    | '/first-time-password-reset'
    | '/login'
    | '/register'
    | '/'
    | '/groups'
    | '/courses/$courseSlug'
    | '/follow-up-network/map'
    | '/follow-up-partners/new'
    | '/follow-up-tutorials/$slug'
    | '/news/$slug'
    | '/notifications/read'
    | '/student-news/$slug'
    | '/study-helper-news/$slug'
    | '/study-helper-tutorials/$slug'
    | '/all-courses'
    | '/follow-up-coordinators'
    | '/follow-up-network'
    | '/follow-up-partners'
    | '/follow-up-request-board'
    | '/follow-up-students'
    | '/follow-up-tutorials'
    | '/follow-ups'
    | '/news'
    | '/notifications'
    | '/student-board'
    | '/study-helper-board'
    | '/tutorials'
    | '/lessons/$lessonSlug'
    | '/quizzes/$quizSlug'
    | '/topic/$topicSlug'
    | '/follow-ups/entries/convert'
    | '/follow-ups/entries'
    | '/follow-ups/pending-requests'
    | '/lessons/$lessonSlug/quiz'
    | '/groups/$groupName/activity'
    | '/groups/$groupName/campaigns'
    | '/members/$memberId/activity'
    | '/members/$memberId/student-notes'
    | '/members/$memberId/study-helpers'
    | '/follow-ups/entries/view/$followUpId'
    | '/follow-ups/pending-requests/view/$followUpId'
    | '/groups/$groupName'
    | '/members/$memberId'
    | '/groups/$groupName/admin/group-avatar'
    | '/groups/$groupName/admin/reassign-students'
    | '/groups/$groupName/admin/student-notice-msg'
    | '/groups/$groupName/campaign/add'
    | '/groups/$groupName/mass-messaging/new'
    | '/groups/$groupName/students/adoption-requests'
    | '/groups/$groupName/students/students-waiting'
    | '/groups/$groupName/students/study-activities'
    | '/groups/$groupName/web-ads-targets/add'
    | '/members/$memberId/course-study/certificates'
    | '/members/$memberId/course-study/study-activities'
    | '/members/$memberId/follow-ups/entries'
    | '/members/$memberId/follow-ups/pending-requests'
    | '/members/$memberId/messages/compose'
    | '/members/$memberId/profile/change-avatar'
    | '/members/$memberId/profile/edit'
    | '/members/$memberId/profile/timeline'
    | '/members/$memberId/settings/export'
    | '/members/$memberId/settings/notifications'
    | '/groups/$groupName/admin'
    | '/groups/$groupName/campaign'
    | '/groups/$groupName/follow-ups'
    | '/groups/$groupName/group-members'
    | '/groups/$groupName/mass-messaging'
    | '/groups/$groupName/student-board'
    | '/groups/$groupName/students'
    | '/groups/$groupName/web-ads-targets'
    | '/groups/$groupName/web-targets'
    | '/members/$memberId/course-study'
    | '/members/$memberId/follow-ups'
    | '/members/$memberId/messages'
    | '/members/$memberId/profile'
    | '/members/$memberId/settings'
    | '/groups/$groupName/admin/member-tagging/add'
    | '/groups/$groupName/follow-ups/follow-up-requests/new'
    | '/groups/$groupName/students/all-students/new'
    | '/members/$memberId/messages/view/$threadId'
    | '/groups/$groupName/admin/member-tagging'
    | '/groups/$groupName/follow-ups/entries'
    | '/groups/$groupName/follow-ups/follow-up-requests'
    | '/groups/$groupName/follow-ups/pending-requests'
    | '/groups/$groupName/students/all-students'
    | '/groups/$groupName/students/quiz-submissions'
    | '/members/$memberId/course-study/quizzes'
    | '/groups/$groupName/admin/member-tagging/edit/$tagId'
    | '/groups/$groupName/follow-ups/follow-up-requests/view/$requestId'
    | '/groups/$groupName/follow-ups/pending-requests/view/$requestId'
    | '/members/$memberId/course-study/quizzes/grade/$submissionId'
    | '/members/$memberId/course-study/quizzes/view/$submissionId'
    | '/groups/$groupName/students/quiz-submissions/quizzes'
    | '/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId'
    | '/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/follow-up-coordinator-application'
    | '/follow-up-partner-application'
    | '/study-helper-application'
    | '/_app/_course'
    | '/_app/contact'
    | '/_app/faqs'
    | '/_app/follow-up-network'
    | '/_app/follow-up-partners'
    | '/_app/follow-up-tutorials'
    | '/_app/follow-ups'
    | '/_app/groups'
    | '/_app/newsletter'
    | '/_auth/first-time-password-reset'
    | '/_auth/login'
    | '/_auth/register'
    | '/_app/'
    | '/_app/_dashboard/groups'
    | '/_app/courses/$courseSlug'
    | '/_app/follow-up-network/map'
    | '/_app/follow-up-partners/new'
    | '/_app/follow-up-tutorials/$slug'
    | '/_app/news/$slug'
    | '/_app/notifications/read'
    | '/_app/student-news/$slug'
    | '/_app/study-helper-news/$slug'
    | '/_app/study-helper-tutorials/$slug'
    | '/_app/all-courses/'
    | '/_app/follow-up-coordinators/'
    | '/_app/follow-up-network/'
    | '/_app/follow-up-partners/'
    | '/_app/follow-up-request-board/'
    | '/_app/follow-up-students/'
    | '/_app/follow-up-tutorials/'
    | '/_app/follow-ups/'
    | '/_app/groups/'
    | '/_app/news/'
    | '/_app/notifications/'
    | '/_app/student-board/'
    | '/_app/study-helper-board/'
    | '/_app/tutorials/'
    | '/_app/_course/lessons/$lessonSlug'
    | '/_app/_course/quizzes/$quizSlug'
    | '/_app/_course/topic/$topicSlug'
    | '/_app/_users/members/$memberId'
    | '/_app/follow-ups/entries/convert'
    | '/_app/follow-ups/entries/'
    | '/_app/follow-ups/pending-requests/'
    | '/_app/_course/lessons/$lessonSlug_/quiz'
    | '/_app/_dashboard/groups/$groupName/activity'
    | '/_app/_dashboard/groups/$groupName/admin'
    | '/_app/_dashboard/groups/$groupName/campaign'
    | '/_app/_dashboard/groups/$groupName/campaigns'
    | '/_app/_dashboard/groups/$groupName/follow-ups'
    | '/_app/_dashboard/groups/$groupName/mass-messaging'
    | '/_app/_dashboard/groups/$groupName/students'
    | '/_app/_dashboard/groups/$groupName/web-ads-targets'
    | '/_app/_users/members/$memberId/activity'
    | '/_app/_users/members/$memberId/course-study'
    | '/_app/_users/members/$memberId/follow-ups'
    | '/_app/_users/members/$memberId/student-notes'
    | '/_app/_users/members/$memberId/study-helpers'
    | '/_app/follow-ups/entries/view/$followUpId'
    | '/_app/follow-ups/pending-requests/view/$followUpId'
    | '/_app/_dashboard/groups/$groupName/'
    | '/_app/_users/members/$memberId/'
    | '/_app/_dashboard/groups/$groupName/admin/group-avatar'
    | '/_app/_dashboard/groups/$groupName/admin/member-tagging'
    | '/_app/_dashboard/groups/$groupName/admin/reassign-students'
    | '/_app/_dashboard/groups/$groupName/admin/student-notice-msg'
    | '/_app/_dashboard/groups/$groupName/campaign/add'
    | '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests'
    | '/_app/_dashboard/groups/$groupName/mass-messaging/new'
    | '/_app/_dashboard/groups/$groupName/students/adoption-requests'
    | '/_app/_dashboard/groups/$groupName/students/all-students'
    | '/_app/_dashboard/groups/$groupName/students/quiz-submissions'
    | '/_app/_dashboard/groups/$groupName/students/students-waiting'
    | '/_app/_dashboard/groups/$groupName/students/study-activities'
    | '/_app/_dashboard/groups/$groupName/web-ads-targets/add'
    | '/_app/_users/members/$memberId/course-study/certificates'
    | '/_app/_users/members/$memberId/course-study/quizzes'
    | '/_app/_users/members/$memberId/course-study/study-activities'
    | '/_app/_users/members/$memberId/follow-ups/entries'
    | '/_app/_users/members/$memberId/follow-ups/pending-requests'
    | '/_app/_users/members/$memberId/messages/compose'
    | '/_app/_users/members/$memberId/profile/change-avatar'
    | '/_app/_users/members/$memberId/profile/edit'
    | '/_app/_users/members/$memberId/profile/timeline'
    | '/_app/_users/members/$memberId/settings/export'
    | '/_app/_users/members/$memberId/settings/notifications'
    | '/_app/_dashboard/groups/$groupName/admin/'
    | '/_app/_dashboard/groups/$groupName/campaign/'
    | '/_app/_dashboard/groups/$groupName/follow-ups/'
    | '/_app/_dashboard/groups/$groupName/group-members/'
    | '/_app/_dashboard/groups/$groupName/mass-messaging/'
    | '/_app/_dashboard/groups/$groupName/student-board/'
    | '/_app/_dashboard/groups/$groupName/students/'
    | '/_app/_dashboard/groups/$groupName/web-ads-targets/'
    | '/_app/_dashboard/groups/$groupName/web-targets/'
    | '/_app/_users/members/$memberId/course-study/'
    | '/_app/_users/members/$memberId/follow-ups/'
    | '/_app/_users/members/$memberId/messages/'
    | '/_app/_users/members/$memberId/profile/'
    | '/_app/_users/members/$memberId/settings/'
    | '/_app/_dashboard/groups/$groupName/admin/member-tagging/add'
    | '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/new'
    | '/_app/_dashboard/groups/$groupName/students/all-students/new'
    | '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes'
    | '/_app/_users/members/$memberId/messages/view/$threadId'
    | '/_app/_dashboard/groups/$groupName/admin/member-tagging/'
    | '/_app/_dashboard/groups/$groupName/follow-ups/entries/'
    | '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/'
    | '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/'
    | '/_app/_dashboard/groups/$groupName/students/all-students/'
    | '/_app/_dashboard/groups/$groupName/students/quiz-submissions/'
    | '/_app/_users/members/$memberId/course-study/quizzes/'
    | '/_app/_dashboard/groups/$groupName/admin/member-tagging/edit/$tagId'
    | '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/view/$requestId'
    | '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/view/$requestId'
    | '/_app/_users/members/$memberId/course-study/quizzes/grade/$submissionId'
    | '/_app/_users/members/$memberId/course-study/quizzes/view/$submissionId'
    | '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/'
    | '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId'
    | '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  FollowUpCoordinatorApplicationRoute: typeof FollowUpCoordinatorApplicationRoute
  FollowUpPartnerApplicationRoute: typeof FollowUpPartnerApplicationRoute
  StudyHelperApplicationRoute: typeof StudyHelperApplicationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/study-helper-application': {
      id: '/study-helper-application'
      path: '/study-helper-application'
      fullPath: '/study-helper-application'
      preLoaderRoute: typeof StudyHelperApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/follow-up-partner-application': {
      id: '/follow-up-partner-application'
      path: '/follow-up-partner-application'
      fullPath: '/follow-up-partner-application'
      preLoaderRoute: typeof FollowUpPartnerApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/follow-up-coordinator-application': {
      id: '/follow-up-coordinator-application'
      path: '/follow-up-coordinator-application'
      fullPath: '/follow-up-coordinator-application'
      preLoaderRoute: typeof FollowUpCoordinatorApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/first-time-password-reset': {
      id: '/_auth/first-time-password-reset'
      path: '/first-time-password-reset'
      fullPath: '/first-time-password-reset'
      preLoaderRoute: typeof AuthFirstTimePasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/newsletter': {
      id: '/_app/newsletter'
      path: '/newsletter'
      fullPath: '/newsletter'
      preLoaderRoute: typeof AppNewsletterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups': {
      id: '/_app/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AppGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-ups': {
      id: '/_app/follow-ups'
      path: '/follow-ups'
      fullPath: '/follow-ups'
      preLoaderRoute: typeof AppFollowUpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-up-tutorials': {
      id: '/_app/follow-up-tutorials'
      path: '/follow-up-tutorials'
      fullPath: '/follow-up-tutorials'
      preLoaderRoute: typeof AppFollowUpTutorialsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-up-partners': {
      id: '/_app/follow-up-partners'
      path: '/follow-up-partners'
      fullPath: '/follow-up-partners'
      preLoaderRoute: typeof AppFollowUpPartnersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-up-network': {
      id: '/_app/follow-up-network'
      path: '/follow-up-network'
      fullPath: '/follow-up-network'
      preLoaderRoute: typeof AppFollowUpNetworkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/faqs': {
      id: '/_app/faqs'
      path: '/faqs'
      fullPath: '/faqs'
      preLoaderRoute: typeof AppFaqsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contact': {
      id: '/_app/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof AppContactRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_course': {
      id: '/_app/_course'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppCourseRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tutorials/': {
      id: '/_app/tutorials/'
      path: '/tutorials'
      fullPath: '/tutorials'
      preLoaderRoute: typeof AppTutorialsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/study-helper-board/': {
      id: '/_app/study-helper-board/'
      path: '/study-helper-board'
      fullPath: '/study-helper-board'
      preLoaderRoute: typeof AppStudyHelperBoardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/student-board/': {
      id: '/_app/student-board/'
      path: '/student-board'
      fullPath: '/student-board'
      preLoaderRoute: typeof AppStudentBoardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/': {
      id: '/_app/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/news/': {
      id: '/_app/news/'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof AppNewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups/': {
      id: '/_app/groups/'
      path: '/'
      fullPath: '/groups/'
      preLoaderRoute: typeof AppGroupsIndexRouteImport
      parentRoute: typeof AppGroupsRoute
    }
    '/_app/follow-ups/': {
      id: '/_app/follow-ups/'
      path: '/'
      fullPath: '/follow-ups/'
      preLoaderRoute: typeof AppFollowUpsIndexRouteImport
      parentRoute: typeof AppFollowUpsRoute
    }
    '/_app/follow-up-tutorials/': {
      id: '/_app/follow-up-tutorials/'
      path: '/'
      fullPath: '/follow-up-tutorials/'
      preLoaderRoute: typeof AppFollowUpTutorialsIndexRouteImport
      parentRoute: typeof AppFollowUpTutorialsRoute
    }
    '/_app/follow-up-students/': {
      id: '/_app/follow-up-students/'
      path: '/follow-up-students'
      fullPath: '/follow-up-students'
      preLoaderRoute: typeof AppFollowUpStudentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-up-request-board/': {
      id: '/_app/follow-up-request-board/'
      path: '/follow-up-request-board'
      fullPath: '/follow-up-request-board'
      preLoaderRoute: typeof AppFollowUpRequestBoardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-up-partners/': {
      id: '/_app/follow-up-partners/'
      path: '/'
      fullPath: '/follow-up-partners/'
      preLoaderRoute: typeof AppFollowUpPartnersIndexRouteImport
      parentRoute: typeof AppFollowUpPartnersRoute
    }
    '/_app/follow-up-network/': {
      id: '/_app/follow-up-network/'
      path: '/'
      fullPath: '/follow-up-network/'
      preLoaderRoute: typeof AppFollowUpNetworkIndexRouteImport
      parentRoute: typeof AppFollowUpNetworkRoute
    }
    '/_app/follow-up-coordinators/': {
      id: '/_app/follow-up-coordinators/'
      path: '/follow-up-coordinators'
      fullPath: '/follow-up-coordinators'
      preLoaderRoute: typeof AppFollowUpCoordinatorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/all-courses/': {
      id: '/_app/all-courses/'
      path: '/all-courses'
      fullPath: '/all-courses'
      preLoaderRoute: typeof AppAllCoursesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/study-helper-tutorials/$slug': {
      id: '/_app/study-helper-tutorials/$slug'
      path: '/study-helper-tutorials/$slug'
      fullPath: '/study-helper-tutorials/$slug'
      preLoaderRoute: typeof AppStudyHelperTutorialsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/study-helper-news/$slug': {
      id: '/_app/study-helper-news/$slug'
      path: '/study-helper-news/$slug'
      fullPath: '/study-helper-news/$slug'
      preLoaderRoute: typeof AppStudyHelperNewsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/student-news/$slug': {
      id: '/_app/student-news/$slug'
      path: '/student-news/$slug'
      fullPath: '/student-news/$slug'
      preLoaderRoute: typeof AppStudentNewsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/read': {
      id: '/_app/notifications/read'
      path: '/notifications/read'
      fullPath: '/notifications/read'
      preLoaderRoute: typeof AppNotificationsReadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/news/$slug': {
      id: '/_app/news/$slug'
      path: '/news/$slug'
      fullPath: '/news/$slug'
      preLoaderRoute: typeof AppNewsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-up-tutorials/$slug': {
      id: '/_app/follow-up-tutorials/$slug'
      path: '/$slug'
      fullPath: '/follow-up-tutorials/$slug'
      preLoaderRoute: typeof AppFollowUpTutorialsSlugRouteImport
      parentRoute: typeof AppFollowUpTutorialsRoute
    }
    '/_app/follow-up-partners/new': {
      id: '/_app/follow-up-partners/new'
      path: '/new'
      fullPath: '/follow-up-partners/new'
      preLoaderRoute: typeof AppFollowUpPartnersNewRouteImport
      parentRoute: typeof AppFollowUpPartnersRoute
    }
    '/_app/follow-up-network/map': {
      id: '/_app/follow-up-network/map'
      path: '/map'
      fullPath: '/follow-up-network/map'
      preLoaderRoute: typeof AppFollowUpNetworkMapRouteImport
      parentRoute: typeof AppFollowUpNetworkRoute
    }
    '/_app/courses/$courseSlug': {
      id: '/_app/courses/$courseSlug'
      path: '/courses/$courseSlug'
      fullPath: '/courses/$courseSlug'
      preLoaderRoute: typeof AppCoursesCourseSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_dashboard/groups': {
      id: '/_app/_dashboard/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AppDashboardGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follow-ups/pending-requests/': {
      id: '/_app/follow-ups/pending-requests/'
      path: '/pending-requests'
      fullPath: '/follow-ups/pending-requests'
      preLoaderRoute: typeof AppFollowUpsPendingRequestsIndexRouteImport
      parentRoute: typeof AppFollowUpsRoute
    }
    '/_app/follow-ups/entries/': {
      id: '/_app/follow-ups/entries/'
      path: '/entries'
      fullPath: '/follow-ups/entries'
      preLoaderRoute: typeof AppFollowUpsEntriesIndexRouteImport
      parentRoute: typeof AppFollowUpsRoute
    }
    '/_app/follow-ups/entries/convert': {
      id: '/_app/follow-ups/entries/convert'
      path: '/entries/convert'
      fullPath: '/follow-ups/entries/convert'
      preLoaderRoute: typeof AppFollowUpsEntriesConvertRouteImport
      parentRoute: typeof AppFollowUpsRoute
    }
    '/_app/_users/members/$memberId': {
      id: '/_app/_users/members/$memberId'
      path: '/members/$memberId'
      fullPath: '/members/$memberId'
      preLoaderRoute: typeof AppUsersMembersMemberIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_course/topic/$topicSlug': {
      id: '/_app/_course/topic/$topicSlug'
      path: '/topic/$topicSlug'
      fullPath: '/topic/$topicSlug'
      preLoaderRoute: typeof AppCourseTopicTopicSlugRouteImport
      parentRoute: typeof AppCourseRoute
    }
    '/_app/_course/quizzes/$quizSlug': {
      id: '/_app/_course/quizzes/$quizSlug'
      path: '/quizzes/$quizSlug'
      fullPath: '/quizzes/$quizSlug'
      preLoaderRoute: typeof AppCourseQuizzesQuizSlugRouteImport
      parentRoute: typeof AppCourseRoute
    }
    '/_app/_course/lessons/$lessonSlug': {
      id: '/_app/_course/lessons/$lessonSlug'
      path: '/lessons/$lessonSlug'
      fullPath: '/lessons/$lessonSlug'
      preLoaderRoute: typeof AppCourseLessonsLessonSlugRouteImport
      parentRoute: typeof AppCourseRoute
    }
    '/_app/_users/members/$memberId/': {
      id: '/_app/_users/members/$memberId/'
      path: '/'
      fullPath: '/members/$memberId/'
      preLoaderRoute: typeof AppUsersMembersMemberIdIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_dashboard/groups/$groupName/': {
      id: '/_app/_dashboard/groups/$groupName/'
      path: '/$groupName'
      fullPath: '/groups/$groupName'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameIndexRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/follow-ups/pending-requests/view/$followUpId': {
      id: '/_app/follow-ups/pending-requests/view/$followUpId'
      path: '/pending-requests/view/$followUpId'
      fullPath: '/follow-ups/pending-requests/view/$followUpId'
      preLoaderRoute: typeof AppFollowUpsPendingRequestsViewFollowUpIdRouteImport
      parentRoute: typeof AppFollowUpsRoute
    }
    '/_app/follow-ups/entries/view/$followUpId': {
      id: '/_app/follow-ups/entries/view/$followUpId'
      path: '/entries/view/$followUpId'
      fullPath: '/follow-ups/entries/view/$followUpId'
      preLoaderRoute: typeof AppFollowUpsEntriesViewFollowUpIdRouteImport
      parentRoute: typeof AppFollowUpsRoute
    }
    '/_app/_users/members/$memberId/study-helpers': {
      id: '/_app/_users/members/$memberId/study-helpers'
      path: '/study-helpers'
      fullPath: '/members/$memberId/study-helpers'
      preLoaderRoute: typeof AppUsersMembersMemberIdStudyHelpersRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/student-notes': {
      id: '/_app/_users/members/$memberId/student-notes'
      path: '/student-notes'
      fullPath: '/members/$memberId/student-notes'
      preLoaderRoute: typeof AppUsersMembersMemberIdStudentNotesRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/follow-ups': {
      id: '/_app/_users/members/$memberId/follow-ups'
      path: '/follow-ups'
      fullPath: '/members/$memberId/follow-ups'
      preLoaderRoute: typeof AppUsersMembersMemberIdFollowUpsRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/course-study': {
      id: '/_app/_users/members/$memberId/course-study'
      path: '/course-study'
      fullPath: '/members/$memberId/course-study'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/activity': {
      id: '/_app/_users/members/$memberId/activity'
      path: '/activity'
      fullPath: '/members/$memberId/activity'
      preLoaderRoute: typeof AppUsersMembersMemberIdActivityRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_dashboard/groups/$groupName/web-ads-targets': {
      id: '/_app/_dashboard/groups/$groupName/web-ads-targets'
      path: '/$groupName/web-ads-targets'
      fullPath: '/groups/$groupName/web-ads-targets'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/students': {
      id: '/_app/_dashboard/groups/$groupName/students'
      path: '/$groupName/students'
      fullPath: '/groups/$groupName/students'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/mass-messaging': {
      id: '/_app/_dashboard/groups/$groupName/mass-messaging'
      path: '/$groupName/mass-messaging'
      fullPath: '/groups/$groupName/mass-messaging'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameMassMessagingRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups'
      path: '/$groupName/follow-ups'
      fullPath: '/groups/$groupName/follow-ups'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/campaigns': {
      id: '/_app/_dashboard/groups/$groupName/campaigns'
      path: '/$groupName/campaigns'
      fullPath: '/groups/$groupName/campaigns'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameCampaignsRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/campaign': {
      id: '/_app/_dashboard/groups/$groupName/campaign'
      path: '/$groupName/campaign'
      fullPath: '/groups/$groupName/campaign'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameCampaignRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/admin': {
      id: '/_app/_dashboard/groups/$groupName/admin'
      path: '/$groupName/admin'
      fullPath: '/groups/$groupName/admin'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/activity': {
      id: '/_app/_dashboard/groups/$groupName/activity'
      path: '/$groupName/activity'
      fullPath: '/groups/$groupName/activity'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameActivityRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_course/lessons/$lessonSlug_/quiz': {
      id: '/_app/_course/lessons/$lessonSlug_/quiz'
      path: '/lessons/$lessonSlug/quiz'
      fullPath: '/lessons/$lessonSlug/quiz'
      preLoaderRoute: typeof AppCourseLessonsLessonSlugQuizRouteImport
      parentRoute: typeof AppCourseRoute
    }
    '/_app/_users/members/$memberId/settings/': {
      id: '/_app/_users/members/$memberId/settings/'
      path: '/settings'
      fullPath: '/members/$memberId/settings'
      preLoaderRoute: typeof AppUsersMembersMemberIdSettingsIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/profile/': {
      id: '/_app/_users/members/$memberId/profile/'
      path: '/profile'
      fullPath: '/members/$memberId/profile'
      preLoaderRoute: typeof AppUsersMembersMemberIdProfileIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/messages/': {
      id: '/_app/_users/members/$memberId/messages/'
      path: '/messages'
      fullPath: '/members/$memberId/messages'
      preLoaderRoute: typeof AppUsersMembersMemberIdMessagesIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/follow-ups/': {
      id: '/_app/_users/members/$memberId/follow-ups/'
      path: '/'
      fullPath: '/members/$memberId/follow-ups/'
      preLoaderRoute: typeof AppUsersMembersMemberIdFollowUpsIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdFollowUpsRoute
    }
    '/_app/_users/members/$memberId/course-study/': {
      id: '/_app/_users/members/$memberId/course-study/'
      path: '/'
      fullPath: '/members/$memberId/course-study/'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyRoute
    }
    '/_app/_dashboard/groups/$groupName/web-targets/': {
      id: '/_app/_dashboard/groups/$groupName/web-targets/'
      path: '/$groupName/web-targets'
      fullPath: '/groups/$groupName/web-targets'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameWebTargetsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/web-ads-targets/': {
      id: '/_app/_dashboard/groups/$groupName/web-ads-targets/'
      path: '/'
      fullPath: '/groups/$groupName/web-ads-targets/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/': {
      id: '/_app/_dashboard/groups/$groupName/students/'
      path: '/'
      fullPath: '/groups/$groupName/students/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/student-board/': {
      id: '/_app/_dashboard/groups/$groupName/student-board/'
      path: '/$groupName/student-board'
      fullPath: '/groups/$groupName/student-board'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentBoardIndexRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/mass-messaging/': {
      id: '/_app/_dashboard/groups/$groupName/mass-messaging/'
      path: '/'
      fullPath: '/groups/$groupName/mass-messaging/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameMassMessagingIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameMassMessagingRoute
    }
    '/_app/_dashboard/groups/$groupName/group-members/': {
      id: '/_app/_dashboard/groups/$groupName/group-members/'
      path: '/$groupName/group-members'
      fullPath: '/groups/$groupName/group-members'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameGroupMembersIndexRouteImport
      parentRoute: typeof AppDashboardGroupsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/'
      path: '/'
      fullPath: '/groups/$groupName/follow-ups/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsRoute
    }
    '/_app/_dashboard/groups/$groupName/campaign/': {
      id: '/_app/_dashboard/groups/$groupName/campaign/'
      path: '/'
      fullPath: '/groups/$groupName/campaign/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameCampaignIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameCampaignRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/': {
      id: '/_app/_dashboard/groups/$groupName/admin/'
      path: '/'
      fullPath: '/groups/$groupName/admin/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminRoute
    }
    '/_app/_users/members/$memberId/settings/notifications': {
      id: '/_app/_users/members/$memberId/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/members/$memberId/settings/notifications'
      preLoaderRoute: typeof AppUsersMembersMemberIdSettingsNotificationsRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/settings/export': {
      id: '/_app/_users/members/$memberId/settings/export'
      path: '/settings/export'
      fullPath: '/members/$memberId/settings/export'
      preLoaderRoute: typeof AppUsersMembersMemberIdSettingsExportRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/profile/timeline': {
      id: '/_app/_users/members/$memberId/profile/timeline'
      path: '/profile/timeline'
      fullPath: '/members/$memberId/profile/timeline'
      preLoaderRoute: typeof AppUsersMembersMemberIdProfileTimelineRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/profile/edit': {
      id: '/_app/_users/members/$memberId/profile/edit'
      path: '/profile/edit'
      fullPath: '/members/$memberId/profile/edit'
      preLoaderRoute: typeof AppUsersMembersMemberIdProfileEditRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/profile/change-avatar': {
      id: '/_app/_users/members/$memberId/profile/change-avatar'
      path: '/profile/change-avatar'
      fullPath: '/members/$memberId/profile/change-avatar'
      preLoaderRoute: typeof AppUsersMembersMemberIdProfileChangeAvatarRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/messages/compose': {
      id: '/_app/_users/members/$memberId/messages/compose'
      path: '/messages/compose'
      fullPath: '/members/$memberId/messages/compose'
      preLoaderRoute: typeof AppUsersMembersMemberIdMessagesComposeRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_users/members/$memberId/follow-ups/pending-requests': {
      id: '/_app/_users/members/$memberId/follow-ups/pending-requests'
      path: '/pending-requests'
      fullPath: '/members/$memberId/follow-ups/pending-requests'
      preLoaderRoute: typeof AppUsersMembersMemberIdFollowUpsPendingRequestsRouteImport
      parentRoute: typeof AppUsersMembersMemberIdFollowUpsRoute
    }
    '/_app/_users/members/$memberId/follow-ups/entries': {
      id: '/_app/_users/members/$memberId/follow-ups/entries'
      path: '/entries'
      fullPath: '/members/$memberId/follow-ups/entries'
      preLoaderRoute: typeof AppUsersMembersMemberIdFollowUpsEntriesRouteImport
      parentRoute: typeof AppUsersMembersMemberIdFollowUpsRoute
    }
    '/_app/_users/members/$memberId/course-study/study-activities': {
      id: '/_app/_users/members/$memberId/course-study/study-activities'
      path: '/study-activities'
      fullPath: '/members/$memberId/course-study/study-activities'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyStudyActivitiesRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyRoute
    }
    '/_app/_users/members/$memberId/course-study/quizzes': {
      id: '/_app/_users/members/$memberId/course-study/quizzes'
      path: '/quizzes'
      fullPath: '/members/$memberId/course-study/quizzes'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyRoute
    }
    '/_app/_users/members/$memberId/course-study/certificates': {
      id: '/_app/_users/members/$memberId/course-study/certificates'
      path: '/certificates'
      fullPath: '/members/$memberId/course-study/certificates'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyCertificatesRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyRoute
    }
    '/_app/_dashboard/groups/$groupName/web-ads-targets/add': {
      id: '/_app/_dashboard/groups/$groupName/web-ads-targets/add'
      path: '/add'
      fullPath: '/groups/$groupName/web-ads-targets/add'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsAddRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/study-activities': {
      id: '/_app/_dashboard/groups/$groupName/students/study-activities'
      path: '/study-activities'
      fullPath: '/groups/$groupName/students/study-activities'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsStudyActivitiesRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/students-waiting': {
      id: '/_app/_dashboard/groups/$groupName/students/students-waiting'
      path: '/students-waiting'
      fullPath: '/groups/$groupName/students/students-waiting'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsStudentsWaitingRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/quiz-submissions': {
      id: '/_app/_dashboard/groups/$groupName/students/quiz-submissions'
      path: '/quiz-submissions'
      fullPath: '/groups/$groupName/students/quiz-submissions'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/all-students': {
      id: '/_app/_dashboard/groups/$groupName/students/all-students'
      path: '/all-students'
      fullPath: '/groups/$groupName/students/all-students'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/adoption-requests': {
      id: '/_app/_dashboard/groups/$groupName/students/adoption-requests'
      path: '/adoption-requests'
      fullPath: '/groups/$groupName/students/adoption-requests'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsAdoptionRequestsRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/mass-messaging/new': {
      id: '/_app/_dashboard/groups/$groupName/mass-messaging/new'
      path: '/new'
      fullPath: '/groups/$groupName/mass-messaging/new'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameMassMessagingNewRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameMassMessagingRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests'
      path: '/follow-up-requests'
      fullPath: '/groups/$groupName/follow-ups/follow-up-requests'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsRoute
    }
    '/_app/_dashboard/groups/$groupName/campaign/add': {
      id: '/_app/_dashboard/groups/$groupName/campaign/add'
      path: '/add'
      fullPath: '/groups/$groupName/campaign/add'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameCampaignAddRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameCampaignRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/student-notice-msg': {
      id: '/_app/_dashboard/groups/$groupName/admin/student-notice-msg'
      path: '/student-notice-msg'
      fullPath: '/groups/$groupName/admin/student-notice-msg'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminStudentNoticeMsgRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/reassign-students': {
      id: '/_app/_dashboard/groups/$groupName/admin/reassign-students'
      path: '/reassign-students'
      fullPath: '/groups/$groupName/admin/reassign-students'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminReassignStudentsRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/member-tagging': {
      id: '/_app/_dashboard/groups/$groupName/admin/member-tagging'
      path: '/member-tagging'
      fullPath: '/groups/$groupName/admin/member-tagging'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/group-avatar': {
      id: '/_app/_dashboard/groups/$groupName/admin/group-avatar'
      path: '/group-avatar'
      fullPath: '/groups/$groupName/admin/group-avatar'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminGroupAvatarRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminRoute
    }
    '/_app/_users/members/$memberId/course-study/quizzes/': {
      id: '/_app/_users/members/$memberId/course-study/quizzes/'
      path: '/'
      fullPath: '/members/$memberId/course-study/quizzes/'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesIndexRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesRoute
    }
    '/_app/_dashboard/groups/$groupName/students/quiz-submissions/': {
      id: '/_app/_dashboard/groups/$groupName/students/quiz-submissions/'
      path: '/'
      fullPath: '/groups/$groupName/students/quiz-submissions/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/all-students/': {
      id: '/_app/_dashboard/groups/$groupName/students/all-students/'
      path: '/'
      fullPath: '/groups/$groupName/students/all-students/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/'
      path: '/pending-requests'
      fullPath: '/groups/$groupName/follow-ups/pending-requests'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/'
      path: '/'
      fullPath: '/groups/$groupName/follow-ups/follow-up-requests/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/entries/': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/entries/'
      path: '/entries'
      fullPath: '/groups/$groupName/follow-ups/entries'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsEntriesIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/member-tagging/': {
      id: '/_app/_dashboard/groups/$groupName/admin/member-tagging/'
      path: '/'
      fullPath: '/groups/$groupName/admin/member-tagging/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingRoute
    }
    '/_app/_users/members/$memberId/messages/view/$threadId': {
      id: '/_app/_users/members/$memberId/messages/view/$threadId'
      path: '/messages/view/$threadId'
      fullPath: '/members/$memberId/messages/view/$threadId'
      preLoaderRoute: typeof AppUsersMembersMemberIdMessagesViewThreadIdRouteImport
      parentRoute: typeof AppUsersMembersMemberIdRoute
    }
    '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes': {
      id: '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes'
      path: '/quizzes'
      fullPath: '/groups/$groupName/students/quiz-submissions/quizzes'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute
    }
    '/_app/_dashboard/groups/$groupName/students/all-students/new': {
      id: '/_app/_dashboard/groups/$groupName/students/all-students/new'
      path: '/new'
      fullPath: '/groups/$groupName/students/all-students/new'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsNewRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/new': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/new'
      path: '/new'
      fullPath: '/groups/$groupName/follow-ups/follow-up-requests/new'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/member-tagging/add': {
      id: '/_app/_dashboard/groups/$groupName/admin/member-tagging/add'
      path: '/add'
      fullPath: '/groups/$groupName/admin/member-tagging/add'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingAddRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingRoute
    }
    '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/': {
      id: '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/'
      path: '/'
      fullPath: '/groups/$groupName/students/quiz-submissions/quizzes/'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute
    }
    '/_app/_users/members/$memberId/course-study/quizzes/view/$submissionId': {
      id: '/_app/_users/members/$memberId/course-study/quizzes/view/$submissionId'
      path: '/view/$submissionId'
      fullPath: '/members/$memberId/course-study/quizzes/view/$submissionId'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesRoute
    }
    '/_app/_users/members/$memberId/course-study/quizzes/grade/$submissionId': {
      id: '/_app/_users/members/$memberId/course-study/quizzes/grade/$submissionId'
      path: '/grade/$submissionId'
      fullPath: '/members/$memberId/course-study/quizzes/grade/$submissionId'
      preLoaderRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRouteImport
      parentRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/view/$requestId': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/pending-requests/view/$requestId'
      path: '/pending-requests/view/$requestId'
      fullPath: '/groups/$groupName/follow-ups/pending-requests/view/$requestId'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsRoute
    }
    '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/view/$requestId': {
      id: '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/view/$requestId'
      path: '/view/$requestId'
      fullPath: '/groups/$groupName/follow-ups/follow-up-requests/view/$requestId'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute
    }
    '/_app/_dashboard/groups/$groupName/admin/member-tagging/edit/$tagId': {
      id: '/_app/_dashboard/groups/$groupName/admin/member-tagging/edit/$tagId'
      path: '/edit/$tagId'
      fullPath: '/groups/$groupName/admin/member-tagging/edit/$tagId'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingRoute
    }
    '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId': {
      id: '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId'
      path: '/view/$submissionId'
      fullPath: '/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute
    }
    '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId': {
      id: '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId'
      path: '/grade/$submissionId'
      fullPath: '/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId'
      preLoaderRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRouteImport
      parentRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute
    }
  }
}

interface AppCourseRouteChildren {
  AppCourseLessonsLessonSlugRoute: typeof AppCourseLessonsLessonSlugRoute
  AppCourseQuizzesQuizSlugRoute: typeof AppCourseQuizzesQuizSlugRoute
  AppCourseTopicTopicSlugRoute: typeof AppCourseTopicTopicSlugRoute
  AppCourseLessonsLessonSlugQuizRoute: typeof AppCourseLessonsLessonSlugQuizRoute
}

const AppCourseRouteChildren: AppCourseRouteChildren = {
  AppCourseLessonsLessonSlugRoute: AppCourseLessonsLessonSlugRoute,
  AppCourseQuizzesQuizSlugRoute: AppCourseQuizzesQuizSlugRoute,
  AppCourseTopicTopicSlugRoute: AppCourseTopicTopicSlugRoute,
  AppCourseLessonsLessonSlugQuizRoute: AppCourseLessonsLessonSlugQuizRoute,
}

const AppCourseRouteWithChildren = AppCourseRoute._addFileChildren(
  AppCourseRouteChildren,
)

interface AppFollowUpNetworkRouteChildren {
  AppFollowUpNetworkMapRoute: typeof AppFollowUpNetworkMapRoute
  AppFollowUpNetworkIndexRoute: typeof AppFollowUpNetworkIndexRoute
}

const AppFollowUpNetworkRouteChildren: AppFollowUpNetworkRouteChildren = {
  AppFollowUpNetworkMapRoute: AppFollowUpNetworkMapRoute,
  AppFollowUpNetworkIndexRoute: AppFollowUpNetworkIndexRoute,
}

const AppFollowUpNetworkRouteWithChildren =
  AppFollowUpNetworkRoute._addFileChildren(AppFollowUpNetworkRouteChildren)

interface AppFollowUpPartnersRouteChildren {
  AppFollowUpPartnersNewRoute: typeof AppFollowUpPartnersNewRoute
  AppFollowUpPartnersIndexRoute: typeof AppFollowUpPartnersIndexRoute
}

const AppFollowUpPartnersRouteChildren: AppFollowUpPartnersRouteChildren = {
  AppFollowUpPartnersNewRoute: AppFollowUpPartnersNewRoute,
  AppFollowUpPartnersIndexRoute: AppFollowUpPartnersIndexRoute,
}

const AppFollowUpPartnersRouteWithChildren =
  AppFollowUpPartnersRoute._addFileChildren(AppFollowUpPartnersRouteChildren)

interface AppFollowUpTutorialsRouteChildren {
  AppFollowUpTutorialsSlugRoute: typeof AppFollowUpTutorialsSlugRoute
  AppFollowUpTutorialsIndexRoute: typeof AppFollowUpTutorialsIndexRoute
}

const AppFollowUpTutorialsRouteChildren: AppFollowUpTutorialsRouteChildren = {
  AppFollowUpTutorialsSlugRoute: AppFollowUpTutorialsSlugRoute,
  AppFollowUpTutorialsIndexRoute: AppFollowUpTutorialsIndexRoute,
}

const AppFollowUpTutorialsRouteWithChildren =
  AppFollowUpTutorialsRoute._addFileChildren(AppFollowUpTutorialsRouteChildren)

interface AppFollowUpsRouteChildren {
  AppFollowUpsIndexRoute: typeof AppFollowUpsIndexRoute
  AppFollowUpsEntriesConvertRoute: typeof AppFollowUpsEntriesConvertRoute
  AppFollowUpsEntriesIndexRoute: typeof AppFollowUpsEntriesIndexRoute
  AppFollowUpsPendingRequestsIndexRoute: typeof AppFollowUpsPendingRequestsIndexRoute
  AppFollowUpsEntriesViewFollowUpIdRoute: typeof AppFollowUpsEntriesViewFollowUpIdRoute
  AppFollowUpsPendingRequestsViewFollowUpIdRoute: typeof AppFollowUpsPendingRequestsViewFollowUpIdRoute
}

const AppFollowUpsRouteChildren: AppFollowUpsRouteChildren = {
  AppFollowUpsIndexRoute: AppFollowUpsIndexRoute,
  AppFollowUpsEntriesConvertRoute: AppFollowUpsEntriesConvertRoute,
  AppFollowUpsEntriesIndexRoute: AppFollowUpsEntriesIndexRoute,
  AppFollowUpsPendingRequestsIndexRoute: AppFollowUpsPendingRequestsIndexRoute,
  AppFollowUpsEntriesViewFollowUpIdRoute:
    AppFollowUpsEntriesViewFollowUpIdRoute,
  AppFollowUpsPendingRequestsViewFollowUpIdRoute:
    AppFollowUpsPendingRequestsViewFollowUpIdRoute,
}

const AppFollowUpsRouteWithChildren = AppFollowUpsRoute._addFileChildren(
  AppFollowUpsRouteChildren,
)

interface AppGroupsRouteChildren {
  AppGroupsIndexRoute: typeof AppGroupsIndexRoute
}

const AppGroupsRouteChildren: AppGroupsRouteChildren = {
  AppGroupsIndexRoute: AppGroupsIndexRoute,
}

const AppGroupsRouteWithChildren = AppGroupsRoute._addFileChildren(
  AppGroupsRouteChildren,
)

interface AppDashboardGroupsGroupNameAdminMemberTaggingRouteChildren {
  AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute
  AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute
  AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute
}

const AppDashboardGroupsGroupNameAdminMemberTaggingRouteChildren: AppDashboardGroupsGroupNameAdminMemberTaggingRouteChildren =
  {
    AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute:
      AppDashboardGroupsGroupNameAdminMemberTaggingAddRoute,
    AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute:
      AppDashboardGroupsGroupNameAdminMemberTaggingIndexRoute,
    AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute:
      AppDashboardGroupsGroupNameAdminMemberTaggingEditTagIdRoute,
  }

const AppDashboardGroupsGroupNameAdminMemberTaggingRouteWithChildren =
  AppDashboardGroupsGroupNameAdminMemberTaggingRoute._addFileChildren(
    AppDashboardGroupsGroupNameAdminMemberTaggingRouteChildren,
  )

interface AppDashboardGroupsGroupNameAdminRouteChildren {
  AppDashboardGroupsGroupNameAdminGroupAvatarRoute: typeof AppDashboardGroupsGroupNameAdminGroupAvatarRoute
  AppDashboardGroupsGroupNameAdminMemberTaggingRoute: typeof AppDashboardGroupsGroupNameAdminMemberTaggingRouteWithChildren
  AppDashboardGroupsGroupNameAdminReassignStudentsRoute: typeof AppDashboardGroupsGroupNameAdminReassignStudentsRoute
  AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute: typeof AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute
  AppDashboardGroupsGroupNameAdminIndexRoute: typeof AppDashboardGroupsGroupNameAdminIndexRoute
}

const AppDashboardGroupsGroupNameAdminRouteChildren: AppDashboardGroupsGroupNameAdminRouteChildren =
  {
    AppDashboardGroupsGroupNameAdminGroupAvatarRoute:
      AppDashboardGroupsGroupNameAdminGroupAvatarRoute,
    AppDashboardGroupsGroupNameAdminMemberTaggingRoute:
      AppDashboardGroupsGroupNameAdminMemberTaggingRouteWithChildren,
    AppDashboardGroupsGroupNameAdminReassignStudentsRoute:
      AppDashboardGroupsGroupNameAdminReassignStudentsRoute,
    AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute:
      AppDashboardGroupsGroupNameAdminStudentNoticeMsgRoute,
    AppDashboardGroupsGroupNameAdminIndexRoute:
      AppDashboardGroupsGroupNameAdminIndexRoute,
  }

const AppDashboardGroupsGroupNameAdminRouteWithChildren =
  AppDashboardGroupsGroupNameAdminRoute._addFileChildren(
    AppDashboardGroupsGroupNameAdminRouteChildren,
  )

interface AppDashboardGroupsGroupNameCampaignRouteChildren {
  AppDashboardGroupsGroupNameCampaignAddRoute: typeof AppDashboardGroupsGroupNameCampaignAddRoute
  AppDashboardGroupsGroupNameCampaignIndexRoute: typeof AppDashboardGroupsGroupNameCampaignIndexRoute
}

const AppDashboardGroupsGroupNameCampaignRouteChildren: AppDashboardGroupsGroupNameCampaignRouteChildren =
  {
    AppDashboardGroupsGroupNameCampaignAddRoute:
      AppDashboardGroupsGroupNameCampaignAddRoute,
    AppDashboardGroupsGroupNameCampaignIndexRoute:
      AppDashboardGroupsGroupNameCampaignIndexRoute,
  }

const AppDashboardGroupsGroupNameCampaignRouteWithChildren =
  AppDashboardGroupsGroupNameCampaignRoute._addFileChildren(
    AppDashboardGroupsGroupNameCampaignRouteChildren,
  )

interface AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteChildren {
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute
}

const AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteChildren: AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteChildren =
  {
    AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute:
      AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsNewRoute,
    AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute:
      AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsIndexRoute,
    AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute:
      AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsViewRequestIdRoute,
  }

const AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteWithChildren =
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute._addFileChildren(
    AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteChildren,
  )

interface AppDashboardGroupsGroupNameFollowUpsRouteChildren {
  AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute: typeof AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteWithChildren
  AppDashboardGroupsGroupNameFollowUpsIndexRoute: typeof AppDashboardGroupsGroupNameFollowUpsIndexRoute
  AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute: typeof AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute
  AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute: typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute
  AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute: typeof AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute
}

const AppDashboardGroupsGroupNameFollowUpsRouteChildren: AppDashboardGroupsGroupNameFollowUpsRouteChildren =
  {
    AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRoute:
      AppDashboardGroupsGroupNameFollowUpsFollowUpRequestsRouteWithChildren,
    AppDashboardGroupsGroupNameFollowUpsIndexRoute:
      AppDashboardGroupsGroupNameFollowUpsIndexRoute,
    AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute:
      AppDashboardGroupsGroupNameFollowUpsEntriesIndexRoute,
    AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute:
      AppDashboardGroupsGroupNameFollowUpsPendingRequestsIndexRoute,
    AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute:
      AppDashboardGroupsGroupNameFollowUpsPendingRequestsViewRequestIdRoute,
  }

const AppDashboardGroupsGroupNameFollowUpsRouteWithChildren =
  AppDashboardGroupsGroupNameFollowUpsRoute._addFileChildren(
    AppDashboardGroupsGroupNameFollowUpsRouteChildren,
  )

interface AppDashboardGroupsGroupNameMassMessagingRouteChildren {
  AppDashboardGroupsGroupNameMassMessagingNewRoute: typeof AppDashboardGroupsGroupNameMassMessagingNewRoute
  AppDashboardGroupsGroupNameMassMessagingIndexRoute: typeof AppDashboardGroupsGroupNameMassMessagingIndexRoute
}

const AppDashboardGroupsGroupNameMassMessagingRouteChildren: AppDashboardGroupsGroupNameMassMessagingRouteChildren =
  {
    AppDashboardGroupsGroupNameMassMessagingNewRoute:
      AppDashboardGroupsGroupNameMassMessagingNewRoute,
    AppDashboardGroupsGroupNameMassMessagingIndexRoute:
      AppDashboardGroupsGroupNameMassMessagingIndexRoute,
  }

const AppDashboardGroupsGroupNameMassMessagingRouteWithChildren =
  AppDashboardGroupsGroupNameMassMessagingRoute._addFileChildren(
    AppDashboardGroupsGroupNameMassMessagingRouteChildren,
  )

interface AppDashboardGroupsGroupNameStudentsAllStudentsRouteChildren {
  AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute
  AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute
}

const AppDashboardGroupsGroupNameStudentsAllStudentsRouteChildren: AppDashboardGroupsGroupNameStudentsAllStudentsRouteChildren =
  {
    AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute:
      AppDashboardGroupsGroupNameStudentsAllStudentsNewRoute,
    AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute:
      AppDashboardGroupsGroupNameStudentsAllStudentsIndexRoute,
  }

const AppDashboardGroupsGroupNameStudentsAllStudentsRouteWithChildren =
  AppDashboardGroupsGroupNameStudentsAllStudentsRoute._addFileChildren(
    AppDashboardGroupsGroupNameStudentsAllStudentsRouteChildren,
  )

interface AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteChildren {
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute
}

const AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteChildren: AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteChildren =
  {
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute:
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesIndexRoute,
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute:
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesGradeSubmissionIdRoute,
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute:
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesViewSubmissionIdRoute,
  }

const AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteWithChildren =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute._addFileChildren(
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteChildren,
  )

interface AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteChildren {
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteWithChildren
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute
}

const AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteChildren: AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteChildren =
  {
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRoute:
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsQuizzesRouteWithChildren,
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute:
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsIndexRoute,
  }

const AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteWithChildren =
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute._addFileChildren(
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteChildren,
  )

interface AppDashboardGroupsGroupNameStudentsRouteChildren {
  AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute: typeof AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute
  AppDashboardGroupsGroupNameStudentsAllStudentsRoute: typeof AppDashboardGroupsGroupNameStudentsAllStudentsRouteWithChildren
  AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute: typeof AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteWithChildren
  AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute: typeof AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute
  AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute: typeof AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute
  AppDashboardGroupsGroupNameStudentsIndexRoute: typeof AppDashboardGroupsGroupNameStudentsIndexRoute
}

const AppDashboardGroupsGroupNameStudentsRouteChildren: AppDashboardGroupsGroupNameStudentsRouteChildren =
  {
    AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute:
      AppDashboardGroupsGroupNameStudentsAdoptionRequestsRoute,
    AppDashboardGroupsGroupNameStudentsAllStudentsRoute:
      AppDashboardGroupsGroupNameStudentsAllStudentsRouteWithChildren,
    AppDashboardGroupsGroupNameStudentsQuizSubmissionsRoute:
      AppDashboardGroupsGroupNameStudentsQuizSubmissionsRouteWithChildren,
    AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute:
      AppDashboardGroupsGroupNameStudentsStudentsWaitingRoute,
    AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute:
      AppDashboardGroupsGroupNameStudentsStudyActivitiesRoute,
    AppDashboardGroupsGroupNameStudentsIndexRoute:
      AppDashboardGroupsGroupNameStudentsIndexRoute,
  }

const AppDashboardGroupsGroupNameStudentsRouteWithChildren =
  AppDashboardGroupsGroupNameStudentsRoute._addFileChildren(
    AppDashboardGroupsGroupNameStudentsRouteChildren,
  )

interface AppDashboardGroupsGroupNameWebAdsTargetsRouteChildren {
  AppDashboardGroupsGroupNameWebAdsTargetsAddRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsAddRoute
  AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute
}

const AppDashboardGroupsGroupNameWebAdsTargetsRouteChildren: AppDashboardGroupsGroupNameWebAdsTargetsRouteChildren =
  {
    AppDashboardGroupsGroupNameWebAdsTargetsAddRoute:
      AppDashboardGroupsGroupNameWebAdsTargetsAddRoute,
    AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute:
      AppDashboardGroupsGroupNameWebAdsTargetsIndexRoute,
  }

const AppDashboardGroupsGroupNameWebAdsTargetsRouteWithChildren =
  AppDashboardGroupsGroupNameWebAdsTargetsRoute._addFileChildren(
    AppDashboardGroupsGroupNameWebAdsTargetsRouteChildren,
  )

interface AppDashboardGroupsRouteChildren {
  AppDashboardGroupsGroupNameActivityRoute: typeof AppDashboardGroupsGroupNameActivityRoute
  AppDashboardGroupsGroupNameAdminRoute: typeof AppDashboardGroupsGroupNameAdminRouteWithChildren
  AppDashboardGroupsGroupNameCampaignRoute: typeof AppDashboardGroupsGroupNameCampaignRouteWithChildren
  AppDashboardGroupsGroupNameCampaignsRoute: typeof AppDashboardGroupsGroupNameCampaignsRoute
  AppDashboardGroupsGroupNameFollowUpsRoute: typeof AppDashboardGroupsGroupNameFollowUpsRouteWithChildren
  AppDashboardGroupsGroupNameMassMessagingRoute: typeof AppDashboardGroupsGroupNameMassMessagingRouteWithChildren
  AppDashboardGroupsGroupNameStudentsRoute: typeof AppDashboardGroupsGroupNameStudentsRouteWithChildren
  AppDashboardGroupsGroupNameWebAdsTargetsRoute: typeof AppDashboardGroupsGroupNameWebAdsTargetsRouteWithChildren
  AppDashboardGroupsGroupNameIndexRoute: typeof AppDashboardGroupsGroupNameIndexRoute
  AppDashboardGroupsGroupNameGroupMembersIndexRoute: typeof AppDashboardGroupsGroupNameGroupMembersIndexRoute
  AppDashboardGroupsGroupNameStudentBoardIndexRoute: typeof AppDashboardGroupsGroupNameStudentBoardIndexRoute
  AppDashboardGroupsGroupNameWebTargetsIndexRoute: typeof AppDashboardGroupsGroupNameWebTargetsIndexRoute
}

const AppDashboardGroupsRouteChildren: AppDashboardGroupsRouteChildren = {
  AppDashboardGroupsGroupNameActivityRoute:
    AppDashboardGroupsGroupNameActivityRoute,
  AppDashboardGroupsGroupNameAdminRoute:
    AppDashboardGroupsGroupNameAdminRouteWithChildren,
  AppDashboardGroupsGroupNameCampaignRoute:
    AppDashboardGroupsGroupNameCampaignRouteWithChildren,
  AppDashboardGroupsGroupNameCampaignsRoute:
    AppDashboardGroupsGroupNameCampaignsRoute,
  AppDashboardGroupsGroupNameFollowUpsRoute:
    AppDashboardGroupsGroupNameFollowUpsRouteWithChildren,
  AppDashboardGroupsGroupNameMassMessagingRoute:
    AppDashboardGroupsGroupNameMassMessagingRouteWithChildren,
  AppDashboardGroupsGroupNameStudentsRoute:
    AppDashboardGroupsGroupNameStudentsRouteWithChildren,
  AppDashboardGroupsGroupNameWebAdsTargetsRoute:
    AppDashboardGroupsGroupNameWebAdsTargetsRouteWithChildren,
  AppDashboardGroupsGroupNameIndexRoute: AppDashboardGroupsGroupNameIndexRoute,
  AppDashboardGroupsGroupNameGroupMembersIndexRoute:
    AppDashboardGroupsGroupNameGroupMembersIndexRoute,
  AppDashboardGroupsGroupNameStudentBoardIndexRoute:
    AppDashboardGroupsGroupNameStudentBoardIndexRoute,
  AppDashboardGroupsGroupNameWebTargetsIndexRoute:
    AppDashboardGroupsGroupNameWebTargetsIndexRoute,
}

const AppDashboardGroupsRouteWithChildren =
  AppDashboardGroupsRoute._addFileChildren(AppDashboardGroupsRouteChildren)

interface AppUsersMembersMemberIdCourseStudyQuizzesRouteChildren {
  AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute
  AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute
  AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute
}

const AppUsersMembersMemberIdCourseStudyQuizzesRouteChildren: AppUsersMembersMemberIdCourseStudyQuizzesRouteChildren =
  {
    AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute:
      AppUsersMembersMemberIdCourseStudyQuizzesIndexRoute,
    AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute:
      AppUsersMembersMemberIdCourseStudyQuizzesGradeSubmissionIdRoute,
    AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute:
      AppUsersMembersMemberIdCourseStudyQuizzesViewSubmissionIdRoute,
  }

const AppUsersMembersMemberIdCourseStudyQuizzesRouteWithChildren =
  AppUsersMembersMemberIdCourseStudyQuizzesRoute._addFileChildren(
    AppUsersMembersMemberIdCourseStudyQuizzesRouteChildren,
  )

interface AppUsersMembersMemberIdCourseStudyRouteChildren {
  AppUsersMembersMemberIdCourseStudyCertificatesRoute: typeof AppUsersMembersMemberIdCourseStudyCertificatesRoute
  AppUsersMembersMemberIdCourseStudyQuizzesRoute: typeof AppUsersMembersMemberIdCourseStudyQuizzesRouteWithChildren
  AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute: typeof AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute
  AppUsersMembersMemberIdCourseStudyIndexRoute: typeof AppUsersMembersMemberIdCourseStudyIndexRoute
}

const AppUsersMembersMemberIdCourseStudyRouteChildren: AppUsersMembersMemberIdCourseStudyRouteChildren =
  {
    AppUsersMembersMemberIdCourseStudyCertificatesRoute:
      AppUsersMembersMemberIdCourseStudyCertificatesRoute,
    AppUsersMembersMemberIdCourseStudyQuizzesRoute:
      AppUsersMembersMemberIdCourseStudyQuizzesRouteWithChildren,
    AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute:
      AppUsersMembersMemberIdCourseStudyStudyActivitiesRoute,
    AppUsersMembersMemberIdCourseStudyIndexRoute:
      AppUsersMembersMemberIdCourseStudyIndexRoute,
  }

const AppUsersMembersMemberIdCourseStudyRouteWithChildren =
  AppUsersMembersMemberIdCourseStudyRoute._addFileChildren(
    AppUsersMembersMemberIdCourseStudyRouteChildren,
  )

interface AppUsersMembersMemberIdFollowUpsRouteChildren {
  AppUsersMembersMemberIdFollowUpsEntriesRoute: typeof AppUsersMembersMemberIdFollowUpsEntriesRoute
  AppUsersMembersMemberIdFollowUpsPendingRequestsRoute: typeof AppUsersMembersMemberIdFollowUpsPendingRequestsRoute
  AppUsersMembersMemberIdFollowUpsIndexRoute: typeof AppUsersMembersMemberIdFollowUpsIndexRoute
}

const AppUsersMembersMemberIdFollowUpsRouteChildren: AppUsersMembersMemberIdFollowUpsRouteChildren =
  {
    AppUsersMembersMemberIdFollowUpsEntriesRoute:
      AppUsersMembersMemberIdFollowUpsEntriesRoute,
    AppUsersMembersMemberIdFollowUpsPendingRequestsRoute:
      AppUsersMembersMemberIdFollowUpsPendingRequestsRoute,
    AppUsersMembersMemberIdFollowUpsIndexRoute:
      AppUsersMembersMemberIdFollowUpsIndexRoute,
  }

const AppUsersMembersMemberIdFollowUpsRouteWithChildren =
  AppUsersMembersMemberIdFollowUpsRoute._addFileChildren(
    AppUsersMembersMemberIdFollowUpsRouteChildren,
  )

interface AppUsersMembersMemberIdRouteChildren {
  AppUsersMembersMemberIdActivityRoute: typeof AppUsersMembersMemberIdActivityRoute
  AppUsersMembersMemberIdCourseStudyRoute: typeof AppUsersMembersMemberIdCourseStudyRouteWithChildren
  AppUsersMembersMemberIdFollowUpsRoute: typeof AppUsersMembersMemberIdFollowUpsRouteWithChildren
  AppUsersMembersMemberIdStudentNotesRoute: typeof AppUsersMembersMemberIdStudentNotesRoute
  AppUsersMembersMemberIdStudyHelpersRoute: typeof AppUsersMembersMemberIdStudyHelpersRoute
  AppUsersMembersMemberIdIndexRoute: typeof AppUsersMembersMemberIdIndexRoute
  AppUsersMembersMemberIdMessagesComposeRoute: typeof AppUsersMembersMemberIdMessagesComposeRoute
  AppUsersMembersMemberIdProfileChangeAvatarRoute: typeof AppUsersMembersMemberIdProfileChangeAvatarRoute
  AppUsersMembersMemberIdProfileEditRoute: typeof AppUsersMembersMemberIdProfileEditRoute
  AppUsersMembersMemberIdProfileTimelineRoute: typeof AppUsersMembersMemberIdProfileTimelineRoute
  AppUsersMembersMemberIdSettingsExportRoute: typeof AppUsersMembersMemberIdSettingsExportRoute
  AppUsersMembersMemberIdSettingsNotificationsRoute: typeof AppUsersMembersMemberIdSettingsNotificationsRoute
  AppUsersMembersMemberIdMessagesIndexRoute: typeof AppUsersMembersMemberIdMessagesIndexRoute
  AppUsersMembersMemberIdProfileIndexRoute: typeof AppUsersMembersMemberIdProfileIndexRoute
  AppUsersMembersMemberIdSettingsIndexRoute: typeof AppUsersMembersMemberIdSettingsIndexRoute
  AppUsersMembersMemberIdMessagesViewThreadIdRoute: typeof AppUsersMembersMemberIdMessagesViewThreadIdRoute
}

const AppUsersMembersMemberIdRouteChildren: AppUsersMembersMemberIdRouteChildren =
  {
    AppUsersMembersMemberIdActivityRoute: AppUsersMembersMemberIdActivityRoute,
    AppUsersMembersMemberIdCourseStudyRoute:
      AppUsersMembersMemberIdCourseStudyRouteWithChildren,
    AppUsersMembersMemberIdFollowUpsRoute:
      AppUsersMembersMemberIdFollowUpsRouteWithChildren,
    AppUsersMembersMemberIdStudentNotesRoute:
      AppUsersMembersMemberIdStudentNotesRoute,
    AppUsersMembersMemberIdStudyHelpersRoute:
      AppUsersMembersMemberIdStudyHelpersRoute,
    AppUsersMembersMemberIdIndexRoute: AppUsersMembersMemberIdIndexRoute,
    AppUsersMembersMemberIdMessagesComposeRoute:
      AppUsersMembersMemberIdMessagesComposeRoute,
    AppUsersMembersMemberIdProfileChangeAvatarRoute:
      AppUsersMembersMemberIdProfileChangeAvatarRoute,
    AppUsersMembersMemberIdProfileEditRoute:
      AppUsersMembersMemberIdProfileEditRoute,
    AppUsersMembersMemberIdProfileTimelineRoute:
      AppUsersMembersMemberIdProfileTimelineRoute,
    AppUsersMembersMemberIdSettingsExportRoute:
      AppUsersMembersMemberIdSettingsExportRoute,
    AppUsersMembersMemberIdSettingsNotificationsRoute:
      AppUsersMembersMemberIdSettingsNotificationsRoute,
    AppUsersMembersMemberIdMessagesIndexRoute:
      AppUsersMembersMemberIdMessagesIndexRoute,
    AppUsersMembersMemberIdProfileIndexRoute:
      AppUsersMembersMemberIdProfileIndexRoute,
    AppUsersMembersMemberIdSettingsIndexRoute:
      AppUsersMembersMemberIdSettingsIndexRoute,
    AppUsersMembersMemberIdMessagesViewThreadIdRoute:
      AppUsersMembersMemberIdMessagesViewThreadIdRoute,
  }

const AppUsersMembersMemberIdRouteWithChildren =
  AppUsersMembersMemberIdRoute._addFileChildren(
    AppUsersMembersMemberIdRouteChildren,
  )

interface AppRouteChildren {
  AppCourseRoute: typeof AppCourseRouteWithChildren
  AppContactRoute: typeof AppContactRoute
  AppFaqsRoute: typeof AppFaqsRoute
  AppFollowUpNetworkRoute: typeof AppFollowUpNetworkRouteWithChildren
  AppFollowUpPartnersRoute: typeof AppFollowUpPartnersRouteWithChildren
  AppFollowUpTutorialsRoute: typeof AppFollowUpTutorialsRouteWithChildren
  AppFollowUpsRoute: typeof AppFollowUpsRouteWithChildren
  AppGroupsRoute: typeof AppGroupsRouteWithChildren
  AppNewsletterRoute: typeof AppNewsletterRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDashboardGroupsRoute: typeof AppDashboardGroupsRouteWithChildren
  AppCoursesCourseSlugRoute: typeof AppCoursesCourseSlugRoute
  AppNewsSlugRoute: typeof AppNewsSlugRoute
  AppNotificationsReadRoute: typeof AppNotificationsReadRoute
  AppStudentNewsSlugRoute: typeof AppStudentNewsSlugRoute
  AppStudyHelperNewsSlugRoute: typeof AppStudyHelperNewsSlugRoute
  AppStudyHelperTutorialsSlugRoute: typeof AppStudyHelperTutorialsSlugRoute
  AppAllCoursesIndexRoute: typeof AppAllCoursesIndexRoute
  AppFollowUpCoordinatorsIndexRoute: typeof AppFollowUpCoordinatorsIndexRoute
  AppFollowUpRequestBoardIndexRoute: typeof AppFollowUpRequestBoardIndexRoute
  AppFollowUpStudentsIndexRoute: typeof AppFollowUpStudentsIndexRoute
  AppNewsIndexRoute: typeof AppNewsIndexRoute
  AppNotificationsIndexRoute: typeof AppNotificationsIndexRoute
  AppStudentBoardIndexRoute: typeof AppStudentBoardIndexRoute
  AppStudyHelperBoardIndexRoute: typeof AppStudyHelperBoardIndexRoute
  AppTutorialsIndexRoute: typeof AppTutorialsIndexRoute
  AppUsersMembersMemberIdRoute: typeof AppUsersMembersMemberIdRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppCourseRoute: AppCourseRouteWithChildren,
  AppContactRoute: AppContactRoute,
  AppFaqsRoute: AppFaqsRoute,
  AppFollowUpNetworkRoute: AppFollowUpNetworkRouteWithChildren,
  AppFollowUpPartnersRoute: AppFollowUpPartnersRouteWithChildren,
  AppFollowUpTutorialsRoute: AppFollowUpTutorialsRouteWithChildren,
  AppFollowUpsRoute: AppFollowUpsRouteWithChildren,
  AppGroupsRoute: AppGroupsRouteWithChildren,
  AppNewsletterRoute: AppNewsletterRoute,
  AppIndexRoute: AppIndexRoute,
  AppDashboardGroupsRoute: AppDashboardGroupsRouteWithChildren,
  AppCoursesCourseSlugRoute: AppCoursesCourseSlugRoute,
  AppNewsSlugRoute: AppNewsSlugRoute,
  AppNotificationsReadRoute: AppNotificationsReadRoute,
  AppStudentNewsSlugRoute: AppStudentNewsSlugRoute,
  AppStudyHelperNewsSlugRoute: AppStudyHelperNewsSlugRoute,
  AppStudyHelperTutorialsSlugRoute: AppStudyHelperTutorialsSlugRoute,
  AppAllCoursesIndexRoute: AppAllCoursesIndexRoute,
  AppFollowUpCoordinatorsIndexRoute: AppFollowUpCoordinatorsIndexRoute,
  AppFollowUpRequestBoardIndexRoute: AppFollowUpRequestBoardIndexRoute,
  AppFollowUpStudentsIndexRoute: AppFollowUpStudentsIndexRoute,
  AppNewsIndexRoute: AppNewsIndexRoute,
  AppNotificationsIndexRoute: AppNotificationsIndexRoute,
  AppStudentBoardIndexRoute: AppStudentBoardIndexRoute,
  AppStudyHelperBoardIndexRoute: AppStudyHelperBoardIndexRoute,
  AppTutorialsIndexRoute: AppTutorialsIndexRoute,
  AppUsersMembersMemberIdRoute: AppUsersMembersMemberIdRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthFirstTimePasswordResetRoute: typeof AuthFirstTimePasswordResetRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthFirstTimePasswordResetRoute: AuthFirstTimePasswordResetRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  FollowUpCoordinatorApplicationRoute: FollowUpCoordinatorApplicationRoute,
  FollowUpPartnerApplicationRoute: FollowUpPartnerApplicationRoute,
  StudyHelperApplicationRoute: StudyHelperApplicationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
